import React, { useEffect, useState, useRef, Fragment } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Home, BarChart3, UserCog, FileText, Bell, ChevronDown, Users, UserPlus, Upload, Link2, Mail, Shield, Search, Filter, MoreVertical, Edit, Trash2, CheckCircle, XCircle, Copy, Download, FileSpreadsheet, AlertCircle, Clock, TrendingUp, Activity, X, ArrowDownAZ, ArrowUpAZ, RotateCcw } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AIInsightPopover } from '../components/AIInsightPopover';
import { SkillsOverview } from '../components/SkillsOverview';
const STATUS_FILTERS = [{
  value: 'all',
  label: 'All statuses'
}, {
  value: 'pending',
  label: 'Pending'
}, {
  value: 'not_assigned',
  label: 'Not Assigned'
}, {
  value: 'active',
  label: 'Active'
}, {
  value: 'inactive',
  label: 'Inactive'
}, {
  value: 'not_started',
  label: 'Not Started'
}, {
  value: 'completed',
  label: 'Completed'
}];
export function UserManagementPage() {
  const navigate = useNavigate();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [userType, setUserType] = useState<'learners' | 'admins'>('learners');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('all');
  const [selectedDepartment, setSelectedDepartment] = useState('all');
  const [selectedCohort, setSelectedCohort] = useState('all');
  const [generatedLink, setGeneratedLink] = useState('');
  const [linkCopied, setLinkCopied] = useState(false);
  const [expandedUserId, setExpandedUserId] = useState<number | null>(null);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const licenseDropdownRef = useRef<HTMLDivElement>(null);
  const departmentDropdownRef = useRef<HTMLDivElement>(null);
  const departmentFilterDropdownRef = useRef<HTMLDivElement>(null);
  const cohortDropdownRef = useRef<HTMLDivElement>(null);
  const cohortFilterDropdownRef = useRef<HTMLDivElement>(null);
  const linkLicenseDropdownRef = useRef<HTMLDivElement>(null);
  const paginationDropdownRef = useRef<HTMLDivElement>(null);
  const actionMenuRefs = useRef<{
    [key: number]: HTMLDivElement | null;
  }>({});
  // Form states
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [department, setDepartment] = useState('');
  const [cohort, setCohort] = useState('');
  const [newDepartmentName, setNewDepartmentName] = useState('');
  const [newCohortName, setNewCohortName] = useState('');
  const [role, setRole] = useState('learner');
  const [selectedLicenses, setSelectedLicenses] = useState<string[]>([]);
  const [isLicenseDropdownOpen, setIsLicenseDropdownOpen] = useState(false);
  const [isDepartmentDropdownOpen, setIsDepartmentDropdownOpen] = useState(false);
  const [isDepartmentFilterDropdownOpen, setIsDepartmentFilterDropdownOpen] = useState(false);
  const [isCohortDropdownOpen, setIsCohortDropdownOpen] = useState(false);
  const [isCohortFilterDropdownOpen, setIsCohortFilterDropdownOpen] = useState(false);
  const [isCreatingDepartment, setIsCreatingDepartment] = useState(false);
  const [isCreatingCohort, setIsCreatingCohort] = useState(false);
  const [isPaginationDropdownOpen, setIsPaginationDropdownOpen] = useState(false);
  const [licenseSearch, setLicenseSearch] = useState('');
  const [addModalStep, setAddModalStep] = useState<'form' | 'confirm'>('form');
  const [acknowledgeChecked, setAcknowledgeChecked] = useState(false);
  const [selectedModalPathways, setSelectedModalPathways] = useState<string[]>([]);
  const [linkLicenses, setLinkLicenses] = useState<string[]>([]);
  const [isLinkLicenseDropdownOpen, setIsLinkLicenseDropdownOpen] = useState(false);
  const [linkLicenseSearch, setLinkLicenseSearch] = useState('');
  const [linkPathways, setLinkPathways] = useState<string[]>([]);
  // New State for Bulk Actions
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [bulkUploadStep, setBulkUploadStep] = useState<'upload' | 'errors'>('upload');
  const [bulkErrorEntries, setBulkErrorEntries] = useState<any[]>([]);
  const [bulkSelectedSkills, setBulkSelectedSkills] = useState<string[]>([]);
  const [bulkSelectedPathways, setBulkSelectedPathways] = useState<string[]>([]);
  const [isBulkSkillDropdownOpen, setIsBulkSkillDropdownOpen] = useState(false);
  const [isBulkPathwayDropdownOpen, setIsBulkPathwayDropdownOpen] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [showNoLicenseToast, setShowNoLicenseToast] = useState(false);
  const [openActionMenuId, setOpenActionMenuId] = useState<number | null>(null);
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);
  const mobileFilterRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5);
  const [sortField, setSortField] = useState<'name' | 'department'>('name');
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');
  const [showAddAdminModal, setShowAddAdminModal] = useState(false);
  const [adminModalStep, setAdminModalStep] = useState<'form' | 'confirm'>('form');
  const [adminEntries, setAdminEntries] = useState([{
    firstName: '',
    lastName: '',
    email: ''
  }]);
  const [adminAcknowledge, setAdminAcknowledge] = useState(false);
  const bulkSkillDropdownRef = useRef<HTMLDivElement>(null);
  const bulkPathwayDropdownRef = useRef<HTMLDivElement>(null);
  const licensesRemaining = 25;
  const totalLicenses = 280;
  const noLicensesAvailable = licensesRemaining === 0;
  const availableSkills = ['AI Functionality Beyond the Hype', 'Active and Empathetic Listening', 'DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'];
  const availablePathways = ['Leadership Essentials', 'Technical Foundations', 'Communication Mastery'];
  const [departments, setDepartments] = useState(['Marketing', 'Human Resources', 'IT', 'Sales', 'Finance', 'Operations']);
  const [cohorts, setCohorts] = useState(['2024 Q1 Onboarding', 'Leadership Track', 'Sales Enablement', 'Technical Upskilling']);
  const pathwayData = [{
    name: 'Leadership Essentials',
    skillCount: 3
  }, {
    name: 'DEI Fundamentals',
    skillCount: 2
  }, {
    name: 'Technical Foundations',
    skillCount: 4
  }, {
    name: 'Communication Mastery',
    skillCount: 3
  }];
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(event.target as Node)) {
        setIsUserMenuOpen(false);
      }
    };
    if (isUserMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isUserMenuOpen]);
  // Close license dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (licenseDropdownRef.current && !licenseDropdownRef.current.contains(event.target as Node)) {
        setIsLicenseDropdownOpen(false);
      }
      if (departmentDropdownRef.current && !departmentDropdownRef.current.contains(event.target as Node)) {
        setIsDepartmentDropdownOpen(false);
        setIsCreatingDepartment(false);
      }
      if (departmentFilterDropdownRef.current && !departmentFilterDropdownRef.current.contains(event.target as Node)) {
        setIsDepartmentFilterDropdownOpen(false);
      }
      if (cohortDropdownRef.current && !cohortDropdownRef.current.contains(event.target as Node)) {
        setIsCohortDropdownOpen(false);
        setIsCreatingCohort(false);
      }
      if (cohortFilterDropdownRef.current && !cohortFilterDropdownRef.current.contains(event.target as Node)) {
        setIsCohortFilterDropdownOpen(false);
      }
      if (linkLicenseDropdownRef.current && !linkLicenseDropdownRef.current.contains(event.target as Node)) {
        setIsLinkLicenseDropdownOpen(false);
      }
      if (bulkSkillDropdownRef.current && !bulkSkillDropdownRef.current.contains(event.target as Node)) {
        setIsBulkSkillDropdownOpen(false);
      }
      if (bulkPathwayDropdownRef.current && !bulkPathwayDropdownRef.current.contains(event.target as Node)) {
        setIsBulkPathwayDropdownOpen(false);
      }
      // Close action menu if clicking outside
      if (openActionMenuId !== null) {
        const menuRef = actionMenuRefs.current[openActionMenuId];
        if (menuRef && !menuRef.contains(event.target as Node)) {
          setOpenActionMenuId(null);
        }
      }
      // Close mobile filter dropdown if clicking outside
      if (mobileFilterRef.current && !mobileFilterRef.current.contains(event.target as Node)) {
        setIsMobileFilterOpen(false);
      }
      if (paginationDropdownRef.current && !paginationDropdownRef.current.contains(event.target as Node)) {
        setIsPaginationDropdownOpen(false);
      }
    };
    if (isLicenseDropdownOpen || isDepartmentDropdownOpen || isDepartmentFilterDropdownOpen || isCohortDropdownOpen || isCohortFilterDropdownOpen || isLinkLicenseDropdownOpen || isBulkSkillDropdownOpen || isBulkPathwayDropdownOpen || openActionMenuId !== null || isMobileFilterOpen || isPaginationDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isLicenseDropdownOpen, isDepartmentDropdownOpen, isDepartmentFilterDropdownOpen, isCohortDropdownOpen, isCohortFilterDropdownOpen, isLinkLicenseDropdownOpen, isBulkSkillDropdownOpen, isBulkPathwayDropdownOpen, openActionMenuId, isMobileFilterOpen, isPaginationDropdownOpen]);
  useEffect(() => {
    const startAssignment = () => {
      setSelectedUsers([1]);
      document.querySelector('[data-phoebe-tour="learner-list"]')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    };
    window.addEventListener('phoebe:assign-learning', startAssignment);
    return () => window.removeEventListener('phoebe:assign-learning', startAssignment);
  }, []);
  // Mock data
  const quickStats = [{
    label: 'Total Learners',
    value: '248',
    change: '+12',
    trend: 'up',
    icon: Users
  }, {
    label: 'Active Admins',
    value: '8',
    change: '+2',
    trend: 'up',
    icon: Shield
  }, {
    label: 'Pending Invites',
    value: '18',
    change: '-5',
    trend: 'down',
    icon: Mail
  }, {
    label: 'Registered This Month',
    value: '32',
    change: '+8',
    trend: 'up',
    icon: TrendingUp
  }];
  const [learners, setLearners] = useState([{
    id: 1,
    name: 'Sarah Johnson',
    email: 'sarah.j@example.com',
    department: 'Marketing',
    cohort: 'Leadership Track',
    status: 'active',
    skills: 4,
    lastActive: '2024-01-15',
    joinDate: '2023-09-12',
    assignedSkills: ['Active and Empathetic Listening', 'Effective Communication', 'EQ for the Workplace', 'Developing EQ and Empathy'],
    assignedPathways: ['Leadership Essentials', 'Communication Mastery']
  }, {
    id: 2,
    name: 'Michael Chen',
    email: 'mchen@example.com',
    department: 'IT',
    cohort: 'Technical Upskilling',
    status: 'inactive',
    skills: 3,
    lastActive: '2023-12-01',
    joinDate: '2023-10-05',
    assignedSkills: ['AI Functionality Beyond the Hype', 'Effective Communication', 'EQ for the Workplace'],
    assignedPathways: ['Technical Foundations']
  }, {
    id: 3,
    name: 'Emily Davis',
    email: 'emily.d@example.com',
    department: 'Human Resources',
    cohort: '2024 Q1 Onboarding',
    status: 'pending',
    skills: 0,
    lastActive: 'Never',
    joinDate: '2024-01-10',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 4,
    name: 'Rachel Green',
    email: 'rachel.g@example.com',
    department: 'Sales',
    cohort: 'Sales Enablement',
    status: 'not_assigned',
    skills: 0,
    lastActive: '2024-01-08',
    joinDate: '2023-07-20',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 8,
    name: 'David Park',
    email: 'david.p@example.com',
    department: 'Operations',
    cohort: 'Leadership Track',
    status: 'not_started',
    skills: 2,
    lastActive: '2024-01-05',
    joinDate: '2023-12-15',
    assignedSkills: ['DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy'],
    assignedPathways: ['Leadership Essentials']
  }, {
    id: 9,
    name: 'Anna Martinez',
    email: 'anna.m@example.com',
    department: 'Finance',
    cohort: 'Leadership Track',
    status: 'completed',
    skills: 6,
    lastActive: '2024-01-14',
    joinDate: '2023-06-01',
    assignedSkills: ['AI Functionality Beyond the Hype', 'Active and Empathetic Listening', 'DEI: Employee Relations and Conflict Resolution', 'Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'],
    assignedPathways: ['Leadership Essentials', 'Technical Foundations', 'Communication Mastery']
  }, {
    id: 10,
    name: 'Brian Adams',
    email: 'brian.adams@example.com',
    department: 'Sales',
    cohort: 'Sales Enablement',
    status: 'active',
    skills: 2,
    lastActive: '2024-01-12',
    joinDate: '2023-11-08',
    assignedSkills: ['Effective Communication', 'Active and Empathetic Listening'],
    assignedPathways: []
  }, {
    id: 11,
    name: 'Priya Nair',
    email: 'priya.nair@example.com',
    department: 'IT',
    cohort: '2024 Q1 Onboarding',
    status: 'pending',
    skills: 0,
    lastActive: 'Never',
    joinDate: '2024-01-18',
    assignedSkills: [],
    assignedPathways: []
  }, {
    id: 12,
    name: 'Marcus Wilson',
    email: 'marcus.wilson@example.com',
    department: 'Operations',
    cohort: 'Technical Upskilling',
    status: 'not_started',
    skills: 3,
    lastActive: 'Never',
    joinDate: '2023-12-20',
    assignedSkills: ['Developing EQ and Empathy', 'EQ for the Workplace', 'Effective Communication'],
    assignedPathways: []
  }, {
    id: 13,
    name: 'Olivia Brooks',
    email: 'olivia.brooks@example.com',
    department: 'Marketing',
    cohort: '2024 Q1 Onboarding',
    status: 'inactive',
    skills: 1,
    lastActive: '2023-11-28',
    joinDate: '2023-08-14',
    assignedSkills: ['AI Functionality Beyond the Hype'],
    assignedPathways: []
  }]);
  const admins = [{
    id: 1,
    name: 'Linda Taylor',
    email: 'linda.taylor@example.com',
    status: 'active',
    role: 'Super Admin',
    lastActive: '2024-01-15',
    joinDate: '2023-01-10'
  }, {
    id: 2,
    name: 'Robert Martinez',
    email: 'robert.m@example.com',
    status: 'active',
    role: 'Admin',
    lastActive: '2024-01-14',
    joinDate: '2023-03-22'
  }, {
    id: 3,
    name: 'Jennifer Lee',
    email: 'jennifer.lee@example.com',
    status: 'active',
    role: 'Admin',
    lastActive: '2024-01-13',
    joinDate: '2023-05-18'
  }];
  const filteredUsers = (userType === 'learners' ? learners : admins).filter(user => {
    const userDepartment = 'department' in user ? user.department || '' : '';
    const userCohort = 'cohort' in user ? user.cohort || '' : '';
    const normalizedSearch = searchQuery.toLowerCase();
    const matchesSearch = user.name.toLowerCase().includes(normalizedSearch) || user.email.toLowerCase().includes(normalizedSearch) || userDepartment.toLowerCase().includes(normalizedSearch) || userCohort.toLowerCase().includes(normalizedSearch);
    const matchesFilter = selectedFilter === 'all' || (selectedFilter === 'not_assigned' ? 'assignedSkills' in user && Array.isArray((user as any).assignedSkills) && (user as any).assignedSkills.length === 0 : user.status === selectedFilter);
    const matchesDepartment = userType !== 'learners' || selectedDepartment === 'all' || userDepartment === selectedDepartment;
    const matchesCohort = userType !== 'learners' || selectedCohort === 'all' || userCohort === selectedCohort;
    return matchesSearch && matchesFilter && matchesDepartment && matchesCohort;
  }).sort((a, b) => {
    const valueA = sortField === 'department' && 'department' in a ? a.department || '' : a.name.trim().split(/\s+/).at(-1) || a.name;
    const valueB = sortField === 'department' && 'department' in b ? b.department || '' : b.name.trim().split(/\s+/).at(-1) || b.name;
    const comparison = valueA.localeCompare(valueB) || a.name.localeCompare(b.name);
    return sortDirection === 'asc' ? comparison : -comparison;
  });
  const toggleSort = (field: 'name' | 'department') => {
    if (sortField === field) {
      setSortDirection(direction => direction === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };
  // Only count selections that belong to the list currently on screen, so the
  // assignment bar never lingers after switching tabs or changing filters
  const activeSelectedUsers = selectedUsers.filter(userId => filteredUsers.some(user => user.id === userId));
  const selectedCount = activeSelectedUsers.length;
  const selectedLearnerLabel = `${selectedCount} ${selectedCount === 1 ? 'learner' : 'learners'}`;
  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / itemsPerPage));
  const safeCurrentPage = Math.min(currentPage, totalPages);
  const paginatedUsers = filteredUsers.slice((safeCurrentPage - 1) * itemsPerPage, safeCurrentPage * itemsPerPage);
  const handleGenerateLink = () => {
    const linkType = userType === 'learners' ? 'learner' : 'admin';
    const newLink = `https://platform.example.com/register/${linkType}?token=${Math.random().toString(36).substr(2, 9)}`;
    setGeneratedLink(newLink);
  };
  const handleCopyLink = () => {
    navigator.clipboard.writeText(generatedLink);
    setLinkCopied(true);
    setTimeout(() => setLinkCopied(false), 2000);
  };
  const handleCreateDepartment = () => {
    const nextDepartment = newDepartmentName.trim();
    if (!nextDepartment) return;
    setDepartments(existing => existing.includes(nextDepartment) ? existing : [...existing, nextDepartment]);
    setDepartment(nextDepartment);
    setNewDepartmentName('');
    setIsCreatingDepartment(false);
    setIsDepartmentDropdownOpen(false);
  };
  const handleCreateCohort = () => {
    const nextCohort = newCohortName.trim();
    if (!nextCohort) return;
    setCohorts(existing => existing.includes(nextCohort) ? existing : [...existing, nextCohort]);
    setCohort(nextCohort);
    setNewCohortName('');
    setIsCreatingCohort(false);
    setIsCohortDropdownOpen(false);
  };
  const handleDownloadCsvTemplate = () => {
    const csv = 'First Name,Last Name,Email,Department\nTaylor,Smith,taylor.smith@example.com,Marketing\nJordan,Lee,jordan.lee@example.com,IT';
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'learner-import-template.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };
  const handleAddUser = () => {
    if (!firstName.trim() || !lastName.trim() || !email.trim() || !department) return;
    const newLearner = {
      id: Date.now(),
      name: `${firstName.trim()} ${lastName.trim()}`,
      email: email.trim(),
      department,
      cohort,
      status: 'pending',
      skills: selectedLicenses.length + selectedModalPathways.reduce((sum, pathway) => sum + (pathwayData.find(item => item.name === pathway)?.skillCount || 0), 0),
      lastActive: 'Never',
      joinDate: new Date().toISOString().split('T')[0],
      assignedSkills: selectedLicenses,
      assignedPathways: selectedModalPathways
    };
    setLearners(prev => [newLearner, ...prev]);
    setSelectedUsers([newLearner.id]);
    setToastMessage(`${newLearner.name} was added to ${department}.`);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 4000);
    setShowAddModal(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setDepartment('');
    setCohort('');
    setNewCohortName('');
    setRole('learner');
    setSelectedLicenses([]);
    setSelectedModalPathways([]);
    setLicenseSearch('');
    setAddModalStep('form');
    setAcknowledgeChecked(false);
  };
  const handleAddAdminEntry = () => {
    setAdminEntries([...adminEntries, {
      firstName: '',
      lastName: '',
      email: ''
    }]);
  };
  const handleAdminEntryChange = (index: number, field: string, value: string) => {
    const newEntries = [...adminEntries];
    newEntries[index] = {
      ...newEntries[index],
      [field]: value
    };
    setAdminEntries(newEntries);
  };
  const handleAdminSubmit = () => {
    const allFilled = adminEntries.every(entry => entry.firstName && entry.lastName && entry.email);
    if (allFilled && adminAcknowledge) {
      setAdminModalStep('confirm');
    }
  };
  const handleCloseAdminModal = () => {
    setShowAddAdminModal(false);
    setAdminModalStep('form');
    setAdminEntries([{
      firstName: '',
      lastName: '',
      email: ''
    }]);
    setAdminAcknowledge(false);
  };
  const toggleLicense = (skill: string) => {
    setSelectedLicenses(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  const toggleModalPathway = (pathway: string) => {
    setSelectedModalPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const selectAllModalPathways = () => {
    const allPathwayNames = pathwayData.map(p => p.name);
    if (selectedModalPathways.length === allPathwayNames.length) {
      setSelectedModalPathways([]);
    } else {
      setSelectedModalPathways([...allPathwayNames]);
    }
  };
  const selectAllModalSkills = () => {
    if (selectedLicenses.length === availableSkills.length) {
      setSelectedLicenses([]);
    } else {
      setSelectedLicenses([...availableSkills]);
    }
  };
  const toggleLinkPathway = (pathway: string) => {
    setLinkPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const selectAllLinkPathways = () => {
    const allPathwayNames = pathwayData.map(p => p.name);
    if (linkPathways.length === allPathwayNames.length) {
      setLinkPathways([]);
    } else {
      setLinkPathways([...allPathwayNames]);
    }
  };
  const selectAllLinkSkills = () => {
    if (linkLicenses.length === availableSkills.length) {
      setLinkLicenses([]);
    } else {
      setLinkLicenses([...availableSkills]);
    }
  };
  const toggleLinkLicense = (skill: string) => {
    setLinkLicenses(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  // Bulk Actions Handlers
  const handleSelectAll = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (noLicensesAvailable) {
      e.preventDefault();
      setShowNoLicenseToast(true);
      setTimeout(() => setShowNoLicenseToast(false), 3000);
      return;
    }
    const pageUserIds = paginatedUsers.map(user => user.id);
    if (e.target.checked) {
      setSelectedUsers(previous => [...new Set([...previous, ...pageUserIds])]);
    } else {
      setSelectedUsers(previous => previous.filter(userId => !pageUserIds.includes(userId)));
    }
  };
  const hasActiveFilters = Boolean(searchQuery) || selectedFilter !== 'all' || selectedDepartment !== 'all' || selectedCohort !== 'all';
  const resetFilters = () => {
    setSearchQuery('');
    setSelectedFilter('all');
    setSelectedDepartment('all');
    setSelectedCohort('all');
    setCurrentPage(1);
    setIsMobileFilterOpen(false);
    setIsDepartmentFilterDropdownOpen(false);
    setIsCohortFilterDropdownOpen(false);
  };
  const handleSelectAllFilteredUsers = () => {
    setSelectedUsers(filteredUsers.map(user => user.id));
  };
  const handleDeselectAllFilteredUsers = () => {
    const filteredUserIds = filteredUsers.map(user => user.id);
    setSelectedUsers(previous => previous.filter(userId => !filteredUserIds.includes(userId)));
  };
  const handleSelectUser = (id: number) => {
    if (noLicensesAvailable) {
      setShowNoLicenseToast(true);
      setTimeout(() => setShowNoLicenseToast(false), 3000);
      return;
    }
    setSelectedUsers(prev => prev.includes(id) ? prev.filter(userId => userId !== id) : [...prev, id]);
  };
  const toggleBulkSkill = (skill: string) => {
    if (skill === 'all') {
      if (bulkSelectedSkills.length === availableSkills.length) {
        setBulkSelectedSkills([]);
      } else {
        setBulkSelectedSkills([...availableSkills]);
      }
      return;
    }
    setBulkSelectedSkills(prev => prev.includes(skill) ? prev.filter(s => s !== skill) : [...prev, skill]);
  };
  const toggleBulkPathway = (pathway: string) => {
    if (pathway === 'all') {
      if (bulkSelectedPathways.length === availablePathways.length) {
        setBulkSelectedPathways([]);
      } else {
        setBulkSelectedPathways([...availablePathways]);
      }
      return;
    }
    setBulkSelectedPathways(prev => prev.includes(pathway) ? prev.filter(p => p !== pathway) : [...prev, pathway]);
  };
  const handleBulkAssign = () => {
    // Simulate assigning skills/pathways
    const totalAssigned = bulkSelectedSkills.length + bulkSelectedPathways.length;
    if (totalAssigned === 0) return;
    setLearners(prev => prev.map(learner => {
      if (selectedUsers.includes(learner.id)) {
        return {
          ...learner,
          skills: learner.skills + totalAssigned,
          status: learner.status === 'pending' ? 'inactive' : learner.status,
          assignedSkills: [...(learner.assignedSkills || []), ...bulkSelectedSkills],
          assignedPathways: [...(learner.assignedPathways || []), ...bulkSelectedPathways]
        };
      }
      return learner;
    }));
    setToastMessage(`Successfully assigned ${totalAssigned} items to ${selectedUsers.length} learners.`);
    setShowSuccessToast(true);
    setTimeout(() => setShowSuccessToast(false), 3000);
    // Reset state
    setSelectedUsers([]);
    setBulkSelectedSkills([]);
    setBulkSelectedPathways([]);
    setIsBulkSkillDropdownOpen(false);
    setIsBulkPathwayDropdownOpen(false);
  };
  const handleSimulateBulkUpload = () => {
    // Transition to error review step with mock data
    setBulkUploadStep('errors');
    setBulkErrorEntries([{
      id: 'err1',
      row: 3,
      firstName: 'John',
      lastName: 'Doe',
      email: 'john.doe@example.com',
      department: 'Marketing',
      errors: {
        email: 'Duplicate email'
      },
      fixed: false
    }, {
      id: 'err2',
      row: 5,
      firstName: 'Jane',
      lastName: '',
      email: 'jane.smith@example.com',
      department: 'Sales',
      errors: {
        lastName: 'Last name is required'
      },
      fixed: false
    }]);
  };
  const handleBulkErrorChange = (id: string, field: string, value: string) => {
    setBulkErrorEntries(prev => prev.map(entry => {
      if (entry.id === id) {
        const newEntry = {
          ...entry,
          [field]: value
        };
        // Clear error for the field if it's being edited
        if (newEntry.errors && newEntry.errors[field]) {
          const newErrors = {
            ...newEntry.errors
          };
          delete newErrors[field];
          newEntry.errors = newErrors;
        }
        newEntry.fixed = false; // Reset fixed status if edited
        return newEntry;
      }
      return entry;
    }));
  };
  const handleFixAndAdd = (id: string) => {
    setBulkErrorEntries(prev => prev.map(entry => {
      if (entry.id === id) {
        // Simple validation simulation
        const newErrors: any = {};
        if (!entry.firstName) newErrors.firstName = 'First name is required';
        if (!entry.lastName) newErrors.lastName = 'Last name is required';
        if (!entry.email) newErrors.email = 'Email is required';else if (!/^\S+@\S+\.\S+$/.test(entry.email)) newErrors.email = 'Invalid email format';
        if (!entry.department) newErrors.department = 'Department is required';
        if (Object.keys(newErrors).length > 0) {
          return {
            ...entry,
            errors: newErrors,
            fixed: false
          };
        }
        return {
          ...entry,
          errors: {},
          fixed: true
        };
      }
      return entry;
    }));
  };
  const handleRemoveBulkError = (id: string) => {
    setBulkErrorEntries(prev => prev.filter(entry => entry.id !== id));
  };
  const handleSubmitBulkErrors = () => {
    const validEntries = bulkErrorEntries.filter(e => e.fixed || Object.keys(e.errors || {}).length === 0);
    if (validEntries.length > 0) {
      const newLearners = validEntries.map((entry, idx) => ({
        id: Date.now() + idx,
        name: `${entry.firstName} ${entry.lastName}`,
        email: entry.email,
        department: entry.department || '',
        status: 'pending',
        skills: 0,
        lastActive: 'Never',
        joinDate: new Date().toISOString().split('T')[0],
        assignedSkills: [],
        assignedPathways: []
      }));
      setLearners(prev => [...newLearners, ...prev]);
      setSelectedUsers(newLearners.map(l => l.id));
      setToastMessage(`Successfully imported ${newLearners.length} learners. Please assign them skills.`);
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 4000);
    }
    setShowBulkModal(false);
    setBulkUploadStep('upload');
    setBulkErrorEntries([]);
  };
  const handleCloseBulkModal = () => {
    setShowBulkModal(false);
    setBulkUploadStep('upload');
    setBulkErrorEntries([]);
  };
  return <div className="flex-1 bg-gray-50 min-h-screen relative pb-24" data-id="element-2439" data-mp="3n8afkn3rdvf9">
      {/* Success Toast */}
      <AnimatePresence data-id="element-2440" data-mp="3i865pfxcvyy0">
        {showSuccessToast && <motion.div initial={{
        opacity: 0,
        y: -50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -50
      }} className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-[#007558] text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3" data-id="element-2441" data-mp="3i7cw8770ivc6">
            <CheckCircle size={20} data-id="element-2442" data-mp="9up5zax1qrsf" />
            <span className="font-medium" data-id="element-2443" data-mp="5qr976v71t2j">{toastMessage}</span>
          </motion.div>}
      </AnimatePresence>

      {/* No License Toast */}
      <AnimatePresence data-id="element-2444" data-mp="yzlr57c43gm">
        {showNoLicenseToast && <motion.div initial={{
        opacity: 0,
        y: -50
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -50
      }} className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-[#DB3725] text-white px-6 py-3 rounded-lg shadow-lg flex items-center gap-3 max-w-md" data-id="element-2445" data-mp="3s73vem6ipyil">
            <AlertCircle size={20} className="flex-shrink-0" data-id="element-2446" data-mp="w2bdo7s44lf5" />
            <span className="font-medium" data-id="element-2447" data-mp="1104j2ylldbed">
              No licenses remaining. Please purchase additional licenses to
              assign skills or pathways.
            </span>
          </motion.div>}
      </AnimatePresence>

      {/* Top Navigation */}
      <div className="bg-white border-b border-gray-200" data-id="element-2448" data-mp="1a2m459pifxzs">
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2449" data-mp="1f0nqc3i8gdfh">
          <div className="flex items-center h-16" data-id="element-2450" data-mp="1eyb6fkswzszs">
            {/* Logo */}
            <div className="text-[#DB3725] font-bold text-xl" data-id="element-2451" data-mp="1jxe58niax2zb">LOGO</div>

            {/* Navigation Links */}
            <nav className="flex items-center gap-4 sm:gap-8 ml-6 sm:ml-12" data-id="element-2452" data-mp="1os1s6hxnppbs">
              <Link data-phoebe-nav="/admin" to="/admin" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2453" data-mp="1toij1jw8qhsk">
                <Home size={18} data-id="element-2454" data-mp="22oyk6mpihcu9" />
                <span className="hidden sm:inline" data-id="element-2455" data-mp="22q9piqylusnh">Admin Hub</span>
              </Link>
              <Link data-phoebe-nav="/analytics" to="/analytics" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2456" data-mp="2oa3ymh2gp84">
                <BarChart3 size={18} data-id="element-2457" data-mp="cdjuhxw9hzu4" />
                <span className="hidden sm:inline" data-id="element-2458" data-mp="cel6c4l3qqcw">Analytics</span>
              </Link>
              <Link data-phoebe-nav="/feedback" to="/feedback" className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors text-sm font-medium" data-id="element-2459" data-mp="7l0i349b9aqw">
                <FileText size={18} data-id="element-2460" data-mp="hd66y549nc1v" />
                <span className="hidden sm:inline" data-id="element-2461" data-mp="hc3j6628ppq6">Reports</span>
              </Link>
              <Link data-phoebe-nav="/assessment" to="/assessment" className="flex items-center gap-2 text-[#30718D] border-b-2 border-[#30718D] pb-[22px] pt-[22px] transition-colors text-sm font-medium" data-id="element-2462" data-mp="vaur1aqief5v">
                <UserCog size={18} data-id="element-2463" data-mp="2x413dhawzbaz" />
                <span className="hidden sm:inline" data-id="element-2464" data-mp="2s4fvghdrnsm4">Users</span>
              </Link>
            </nav>

            {/* Right Side - User Info */}
            <div className="flex items-center gap-2 sm:gap-4 ml-auto" data-id="element-2465" data-mp="17nf4ixcg0gj5">
              <Link data-phoebe-nav="/alerts" to="/alerts" aria-label="Notifications" className="relative p-2 text-gray-600 hover:text-gray-900 transition-colors" data-id="element-2466" data-mp="1cm036sc1qs5h">
                <Bell size={20} data-id="element-2467" data-mp="yrz94bw1htbg" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-[#DB3725] rounded-full" data-id="element-2468" data-mp="12v5e7g7f1egc"></span>
              </Link>
              <div className="relative" ref={userMenuRef} data-id="element-2469" data-mp="ouumkaya7vu4">
                <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="flex items-center gap-3 hover:bg-gray-50 rounded-lg px-2 py-1 transition-colors" data-id="element-2470" data-mp="tuz4m5eu8ymg">
                  <div className="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-sm font-medium" data-id="element-2471" data-mp="fx0td8vtdib6">
                    LT
                  </div>
                  <span className="hidden sm:inline text-sm font-medium text-gray-900" data-id="element-2472" data-mp="2aajwqzcizv4e">
                    Linda Taylor
                  </span>
                  <ChevronDown size={16} className="text-gray-600" data-id="element-2473" data-mp="1pk67krfdvssp" />
                </button>

                {isUserMenuOpen && <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50" data-id="element-2474" data-mp="1klcx77ve8hwr">
                    <div className="py-2" data-id="element-2475" data-mp="1fkp50ivfhv0y">
                      <Link to="/profile" className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2476" data-mp="1fntiy7yp454t">
                        <Users size={18} className="text-gray-600" data-id="element-2477" data-mp="16mdeshyh4z91" />
                        <span className="font-medium text-gray-900" data-id="element-2478" data-mp="11uvdfssjgwnj">
                          Profile
                        </span>
                      </Link>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2479" data-mp="wtegg8d6duc8">
                        <Home size={18} className="text-gray-600" data-id="element-2480" data-mp="mxunnutwrbrp" />
                        <span className="font-medium text-gray-900" data-id="element-2481" data-mp="mz5qnsfj4fhr">
                          Learner Hub
                        </span>
                      </button>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2482" data-mp="2uijmokavn2r6">
                        <UserCog size={18} className="text-gray-600" data-id="element-2483" data-mp="33jrkz2de83l9" />
                        <span className="font-medium text-gray-900" data-id="element-2484" data-mp="33kkhlain1cpo">
                          Admin Hub
                        </span>
                      </button>
                      <div className="border-t border-gray-200 my-2" data-id="element-2485" data-mp="2aw55owuszaik"></div>
                      <button className="w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-gray-50 transition-colors text-sm" data-id="element-2486" data-mp="2ftx6kgdfe6yw">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-600" data-id="element-2487" data-mp="2kshzrvu9fqdu">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" data-id="element-2488" data-mp="1s3t4idfvyfa0"></path>
                          <polyline points="16 17 21 12 16 7" data-id="element-2489" data-mp="1x2xdb2yweazt"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12" data-id="element-2490" data-mp="1p2rekk3fupmp"></line>
                        </svg>
                        <span className="font-medium text-gray-900" data-id="element-2491" data-mp="1l1nybwhharky">
                          Logout
                        </span>
                      </button>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8" data-id="element-2492" data-mp="163ludl6jc436">
        {/* Header with Toggle */}
        <div className="mb-8" data-id="element-2493" data-mp="123lh43v69yxp">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4" data-id="element-2494" data-mp="124czgczre061">
            <div data-id="element-2495" data-mp="1g3midkfcn8dp">
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2" data-id="element-2496" data-mp="1fzynagu9adwv">
                User Management
              </h1>
              <p className="text-gray-600 text-sm sm:text-base" data-id="element-2497" data-mp="2rgylft3abmyt">
                Manage learners across your platform
              </p>
            </div>

            {/* Add Admin Button */}
            <div className="flex items-center self-start" data-id="element-2498" data-mp="8a4dhpmjye44">
              <button data-phoebe-tour="add-admin" onClick={() => setShowAddAdminModal(true)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors bg-white shadow-sm" data-id="element-2499" data-mp="8cqkno5j6rlt">
                <Shield size={16} data-id="element-2500" data-mp="4a2938pfn6l5" />
                Add Admin
              </button>
            </div>
          </div>
        </div>

        <section aria-labelledby="learner-workflow-title" className="mb-8 rounded-xl border border-[#30718D]/15 bg-[#EAF4F7] px-4 py-4 sm:px-6" data-id="element-2501" data-mp="rzeq2ur04iy0">
          <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between" data-id="element-2502" data-mp="i9brmf142csa">
            <div data-id="element-2503" data-mp="n7d7ys75jy02">
              <h2 id="learner-workflow-title" className="text-sm font-bold text-[#001823]" data-id="element-2504" data-mp="n6v2r62ii9g0">A simple learner-management flow</h2>
              <p className="mt-1 text-sm text-[#365866]" data-id="element-2505" data-mp="1aw6870ut4s0h">Add learners, find them in the table, then review capacity before assigning skills or pathways.</p>
            </div>
            <ol className="flex flex-wrap items-center gap-2 text-xs font-semibold text-[#236B8C]" aria-label="Learner management steps" data-id="element-2506" data-mp="3bsdt6omp2hqp">
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2507" data-mp="36yj393ghx6j6">1. Add learners</li>
              <li aria-hidden="true" className="hidden text-[#5593B1] sm:block" data-id="element-2508" data-mp="321sqaozzmr1z">→</li>
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2509" data-mp="2x40wtqjp2wvo">2. Review learners</li>
              <li aria-hidden="true" className="hidden text-[#5593B1] sm:block" data-id="element-2510" data-mp="3upoibgem3usf">→</li>
              <li className="rounded-full bg-white px-3 py-1.5 shadow-sm" data-id="element-2511" data-mp="3pseuu6as9t78">3. Assign learning</li>
            </ol>
          </div>
        </section>

        {/* Quick Actions */}
        <div data-phoebe-tour="learners" className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-8" data-id="element-2512" data-mp="3gqyms57fy366">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-phoebe-tour="add-individual" onClick={() => setShowAddModal(true)} className="group bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer" data-id="element-2513" data-mp="29d3sayu8b1ug">
            <div className="flex items-center gap-4" data-id="element-2514" data-mp="tu5ufmjyiat8">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#30718D] to-[#265a70] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2515" data-mp="tsl4694ode16">
                <UserPlus size={24} className="text-white" data-id="element-2516" data-mp="13ixk1o1joj0z" />
              </div>
              <div className="flex-1" data-id="element-2517" data-mp="18i0sligqh7dp">
                <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-[#30718D] transition-colors" data-id="element-2518" data-mp="18gz4odemcqek">
                  Add Individual Learner
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2519" data-mp="1hi71ss5efl72">
                  Register a single learner
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} data-phoebe-tour="bulk-upload-learners" onClick={() => setShowBulkModal(true)} className="group bg-white rounded-xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all cursor-pointer" data-id="element-2520" data-mp="3ja1x3x7cld34">
            <div className="flex items-center gap-4" data-id="element-2521" data-mp="dt5ko5iimcrr">
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#007558] to-[#005a44] flex items-center justify-center group-hover:scale-110 transition-transform" data-id="element-2522" data-mp="druey05ieuy0">
                <Upload size={24} className="text-white" data-id="element-2523" data-mp="3ha488pl60jaz" />
              </div>
              <div className="flex-1" data-id="element-2524" data-mp="3m85q576uuckv">
                <h3 className="text-lg font-bold text-gray-900 mb-1 group-hover:text-[#007558] transition-colors" data-id="element-2525" data-mp="3m74dwze3rk1k">
                  Bulk Upload Learners
                </h3>
                <p className="text-sm text-gray-600" data-id="element-2526" data-mp="2tiozadyvv3qr">
                  Import multiple learners via CSV
                </p>
              </div>
            </div>
          </motion.div>
        </div>

        {/* User List */}
        <div data-phoebe-tour="learner-list" className="bg-white rounded-xl shadow-sm border border-gray-100" data-id="element-2527" data-mp="1fmxha5g3e7iv">
          <div className="p-4 sm:p-6 border-b border-gray-200" data-id="element-2528" data-mp="1bk0r9to8394w">
            <div className="flex items-center justify-between mb-4" data-id="element-2529" data-mp="16lqwvlabockc">
              <div className="flex items-center gap-2" data-id="element-2530" data-mp="11ogz9ics4ulf">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-2531" data-mp="11q1uzbatyjkv">
                  All Learners ({filteredUsers.length})
                </h2>
                <AIInsightPopover headline="A focused follow-up could activate more learners" insightBeforeMetric="There are" highlightedMetric="4 learners" insightAfterMetric=" who are pending or have not started." explanation="A targeted reminder with a clear first step can help move these learners into active training." briefing={{
                metrics: [{
                  label: 'Learners needing follow-up',
                  value: '4'
                }, {
                  label: 'Pending registration',
                  value: '2'
                }, {
                  label: 'Not started',
                  value: '2'
                }],
                signals: ['Emily Davis and Priya Nair are pending account registration.', 'David Park and Marcus Wilson have not started their assigned learning.'],
                actions: ['Show the 4 learners', 'Draft a reminder for pending learners', 'Plan outreach for learners who have not started'],
                actionResponses: {
                  'Show the 4 learners': '**Learners needing follow-up**\n\n• Emily Davis — Pending registration\n• Priya Nair — Pending registration\n• David Park — Not started\n• Marcus Wilson — Not started\n\nStart with the two pending learners by resending their account-creation email, then send a focused learning reminder to David and Marcus.'
                }
              }} align="left" data-id="element-2532" data-mp="rxw27zcr7y4m" />
              </div>
            </div>

            {/* Search and Filter */}
            <div className="flex flex-col items-stretch gap-3 xl:flex-row xl:items-center xl:gap-4" data-id="element-2533" data-mp="dadxj0z6z3i7">
              <div className="relative w-full xl:flex-1" data-id="element-2534" data-mp="10zyqmcp27h57">
                <Search size={18} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#5E7079]" data-id="element-2535" data-mp="15rq9e11z4iks" />
                <input type="text" placeholder="Search name, email, or department" value={searchQuery} onChange={e => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }} className="w-full rounded-lg border border-gray-300 py-2.5 pl-11 pr-4 text-sm text-gray-900 placeholder:text-[#5E7079] focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-2536" data-mp="2qhvnefuaopg8" />
              </div>
              {userType === 'learners' && <div className="relative w-full sm:w-52 xl:flex-none" ref={departmentFilterDropdownRef} data-id="element-2537" data-mp="27ldnhb5alj8w">
                  <button type="button" onClick={() => setIsDepartmentFilterDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isDepartmentFilterDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isDepartmentFilterDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2538" data-mp="22maqmdzgujc0">
                    <span className="truncate" data-id="element-2539" data-mp="1xi9yke0lz8ar">{selectedDepartment === 'all' ? 'All departments' : selectedDepartment || 'Unassigned'}</span>
                    <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isDepartmentFilterDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2540" data-mp="26hdj7mffbvrd" />
                  </button>
                  {isDepartmentFilterDropdownOpen && <div role="listbox" aria-label="Filter learners by department" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2541" data-mp="2geryvjtiwgim">
                      {[{
                  value: 'all',
                  label: 'All departments'
                }, ...departments.map(item => ({
                  value: item,
                  label: item
                })), {
                  value: '',
                  label: 'Unassigned'
                }].map((option, index, options) => <button key={option.value || 'unassigned'} type="button" role="option" aria-selected={selectedDepartment === option.value} onClick={() => {
                  setSelectedDepartment(option.value);
                  setCurrentPage(1);
                  setIsDepartmentFilterDropdownOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedDepartment === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2542" data-mp="2z6kgyj720hbk" data-mpi={index}>
                        {option.label}
                      </button>)}
                    </div>}
                </div>}
              {userType === 'learners' && <div className="relative w-full sm:w-52 xl:flex-none" ref={cohortFilterDropdownRef} data-id="element-2543" data-mp="3s2ai0j3o2bms">
                  <button type="button" onClick={() => setIsCohortFilterDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isCohortFilterDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isCohortFilterDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2544" data-mp="3n7ebyf1lhnqo">
                    <span className="truncate" data-id="element-2545" data-mp="2dzb7bebuohtn">{selectedCohort === 'all' ? 'All cohorts' : selectedCohort || 'No cohort'}</span>
                    <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isCohortFilterDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2546" data-mp="1z9nb2rij09cs" />
                  </button>
                  {isCohortFilterDropdownOpen && <div role="listbox" aria-label="Filter learners by cohort" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2547" data-mp="1vao3ez5etyhn">
                      {[{
                  value: 'all',
                  label: 'All cohorts'
                }, ...cohorts.map(item => ({
                  value: item,
                  label: item
                })), {
                  value: '',
                  label: 'No cohort'
                }].map((option, index, options) => <button key={option.value || 'no-cohort'} type="button" role="option" aria-selected={selectedCohort === option.value} onClick={() => {
                  setSelectedCohort(option.value);
                  setCurrentPage(1);
                  setIsCohortFilterDropdownOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedCohort === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2548" data-mp="3aosho6ls2s1o" data-mpi={index}>
                        {option.label}
                      </button>)}
                    </div>}
                </div>}
              {/* Status filter */}
              <div className="relative w-full sm:w-52 xl:flex-none" ref={mobileFilterRef} data-id="element-2549" data-mp="1wrtoovvrcr8r">
                <button type="button" onClick={() => setIsMobileFilterOpen(!isMobileFilterOpen)} aria-haspopup="listbox" aria-expanded={isMobileFilterOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-3 py-2 text-left text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isMobileFilterOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2550" data-mp="1rsgu1oynafvm">
                  <span className="flex min-w-0 items-center gap-2" data-id="element-2551" data-mp="3cnoerxs8f4bf">
                    <Filter size={16} aria-hidden="true" className="flex-shrink-0 text-gray-400" data-id="element-2552" data-mp="3hh92mx042hww" />
                    <span className="truncate" data-id="element-2553" data-mp="3me99390vhmoj">{STATUS_FILTERS.find(option => option.value === selectedFilter)?.label || 'All statuses'}</span>
                  </span>
                  <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isMobileFilterOpen ? 'rotate-180' : ''}`} data-id="element-2554" data-mp="2tqdfweaiicwi" />
                </button>
                {isMobileFilterOpen && <div role="listbox" aria-label="Filter learners by status" className="absolute z-30 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2555" data-mp="33p2zqclyy7fe">
                    {STATUS_FILTERS.map((option, index, options) => <button key={option.value} type="button" role="option" aria-selected={selectedFilter === option.value} onClick={() => {
                  setSelectedFilter(option.value);
                  setCurrentPage(1);
                  setIsMobileFilterOpen(false);
                }} className={`flex w-full items-center px-3 py-2.5 text-left text-sm transition-colors ${index < options.length - 1 ? 'border-b border-gray-100' : ''} ${selectedFilter === option.value ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2556" data-mp="ix0vj1d6h8zm" data-mpi={index}>
                        {option.label}
                      </button>)}
                  </div>}
              </div>
              <button type="button" onClick={resetFilters} disabled={!hasActiveFilters} className="flex w-full items-center justify-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-[#30718D] transition-colors hover:bg-[#30718D]/10 focus:outline-none focus:ring-2 focus:ring-[#30718D] disabled:cursor-not-allowed disabled:text-gray-400 disabled:hover:bg-transparent sm:w-auto xl:ml-auto" data-id="element-2557" data-mp="1at0e3jb2gy4i">
                <RotateCcw size={15} aria-hidden="true" data-id="element-2558" data-mp="3qfrbut0n3ld8" />
                Reset filters
              </button>
            </div>
            {paginatedUsers.length > 0 && paginatedUsers.every(user => selectedUsers.includes(user.id)) && <div className="mt-4 flex flex-col gap-2 rounded-lg border border-[#30718D]/20 bg-[#30718D]/5 px-4 py-3 text-sm sm:flex-row sm:items-center sm:justify-between" data-id="element-2559" data-mp="40omy0ocgk2r">
                {selectedUsers.length === filteredUsers.length ? <>
                    <p className="font-medium text-[#236B8C]" data-id="element-2560" data-mp="32j3qwqzvhqws">All {filteredUsers.length} learners in this table are selected.</p>
                    <button type="button" onClick={handleDeselectAllFilteredUsers} className="w-fit font-semibold text-[#30718D] underline decoration-1 underline-offset-4 hover:text-[#265A70] focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:ring-offset-2" data-id="element-2561" data-mp="3gjo7dgibfan4">Deselect all</button>
                  </> : <>
                    <p className="text-gray-700" data-id="element-2562" data-mp="rq99etjphzgs">All {paginatedUsers.length} learners on this page are selected.</p>
                    <button type="button" onClick={handleSelectAllFilteredUsers} className="w-fit font-semibold text-[#30718D] underline decoration-1 underline-offset-4 hover:text-[#265A70] focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:ring-offset-2" data-id="element-2563" data-mp="z90hhbqp0tr2">Select all {filteredUsers.length} learners</button>
                  </>}
              </div>}
          </div>

          {/* Users Table */}
          <div className="overflow-x-auto" data-id="element-2564" data-mp="1i1l1s4sbtqj9">
            <table className="w-full sm:min-w-[1080px]" data-id="element-2565" data-mp="1n0fjt4igzb2b">
              <thead data-id="element-2566" data-mp="1n1z18yfv3s5o">
                <tr className="border-b border-gray-200 bg-gray-50" data-id="element-2567" data-mp="18azwjyi5dnrd">
                  <th data-phoebe-tour="select-all" className="py-3 pl-3 pr-1 sm:px-6 w-8 sm:w-12" data-id="element-2568" data-mp="18aq8iggnxqob">
                    <input type="checkbox" aria-label="Select all learners on this page" checked={paginatedUsers.length > 0 && paginatedUsers.every(user => selectedUsers.includes(user.id))} onChange={handleSelectAll} className={`w-4 h-4 rounded border-gray-300 transition-colors ${noLicensesAvailable ? 'opacity-40 cursor-pointer accent-gray-400' : 'text-[#30718D] focus:ring-[#30718D] cursor-pointer'}`} data-id="element-2569" data-mp="1d803ebmtmujj" />
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-2570" data-mp="26lfsrfz3twqe">
                    <button onClick={() => toggleSort('name')} aria-label={`Sort learners by last name ${sortField === 'name' && sortDirection === 'asc' ? 'descending' : 'ascending'}`} className="flex items-center gap-1.5 text-[#374151] hover:text-gray-900 transition-colors" data-id="element-2571" data-mp="21mv3gble4xgq">
                      <span data-id="element-2572" data-mp="1ruyshzy7hcv3">Name</span>
                      {sortField === 'name' && (sortDirection === 'asc' ? <ArrowDownAZ size={18} aria-hidden="true" strokeWidth={2} data-id="element-2573" data-mp="1mvm7lkqwafv5" /> : <ArrowUpAZ size={18} aria-hidden="true" strokeWidth={2} data-id="element-2574" data-mp="1ix4wyr89mn8z" />)}
                    </button>
                  </th>
                  {userType === 'learners' && <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden md:table-cell" data-id="element-2575" data-mp="18xxj82xmcqlc">
                    <button onClick={() => toggleSort('department')} className="flex items-center gap-1 hover:text-gray-900 transition-colors" data-id="element-2576" data-mp="3klsrm8wzyovi">
                      Department
                      {sortField === 'department' && <span className="text-xs text-gray-400" data-id="element-2577" data-mp="3uj71tqsbuhfd">
                        {sortDirection === 'asc' ? '↑' : '↓'}
                      </span>}
                    </button>
                  </th>}
                  {userType === 'learners' && <th className="hidden lg:table-cell text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-2578" data-mp="31wmer2ivwrhm">
                    Cohort
                  </th>}
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700" data-id="element-2579" data-mp="3aueto5kp1x4h">
                    Status
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden sm:table-cell" data-id="element-2580" data-mp="3fo0zpewcr2rb">
                    Skill Modules
                  </th>
                  <th className="text-left py-3 px-3 sm:px-6 font-semibold text-sm text-gray-700 hidden sm:table-cell" data-id="element-2581" data-mp="2n42f4buy124x">
                    Last Active
                  </th>
                  <th className="w-16 py-3 px-2 text-center font-semibold text-sm text-gray-700 sm:w-24 sm:px-6" data-id="element-2582" data-mp="1z38kwi887zqv">
                    Details
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-2583" data-mp="28zlbv8cdzzhx">
                <AnimatePresence mode="wait" data-id="element-2584" data-mp="28ya652zdsho6">
                  {paginatedUsers.map((user, index) => <Fragment key={`${userType}-${user.id}`} data-id="element-2585" data-mp="2mq6vx0dkufhe" data-mpi={index}>
                      <motion.tr initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} exit={{
                    opacity: 0,
                    y: -10
                  }} transition={{
                    delay: index * 0.05
                  }} onClick={e => {
                    const target = e.target as HTMLElement;
                    if (!target.closest('input[type="checkbox"]') && !target.closest('button')) {
                      setExpandedUserId(expandedUserId === user.id ? null : user.id);
                    }
                  }} className={`border-b border-gray-100 transition-colors cursor-pointer ${expandedUserId === user.id ? 'bg-gray-50' : 'hover:bg-gray-50'}`} data-id="element-2586" data-mp="2ht6rsv0afmsx">
                        <td className="py-3 sm:py-4 pl-3 pr-1 sm:px-6" data-id="element-2587" data-mp="348f6jr4ir7jf">
                          <input type="checkbox" checked={selectedUsers.includes(user.id)} onChange={() => handleSelectUser(user.id)} className={`w-4 h-4 rounded border-gray-300 transition-colors ${noLicensesAvailable ? 'opacity-40 cursor-pointer accent-gray-400' : 'text-[#30718D] focus:ring-[#30718D] cursor-pointer'}`} data-id="element-2588" data-mp="2q960hka11tt6" />
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6" data-id="element-2589" data-mp="2lauop406998b">
                          <div className="flex items-center gap-2 sm:gap-3" data-id="element-2590" data-mp="el6e8gexzczu">
                            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-[#30718D] flex items-center justify-center text-white text-xs sm:text-sm font-bold flex-shrink-0" data-id="element-2591" data-mp="jjregfu71woa">
                              {user.name.split(' ').map(n => n[0]).join('')}
                            </div>
                            <div className="min-w-0" data-id="element-2592" data-mp="83msbmpbockq">
                              <div className="truncate text-sm font-medium text-gray-900" data-id="element-2593" data-mp="844suvj0pcyg">
                                {user.name}
                              </div>
                              <div className="truncate text-xs text-gray-700 sm:text-sm" data-id="element-2594" data-mp="10rijyd01bean">
                                {user.email}
                              </div>
                              {/* Mobile-only summary of the hidden columns */}
                              <div className="mt-1 flex flex-wrap items-center gap-x-2 gap-y-1 text-[11px] text-gray-500 sm:hidden" data-id="element-2595" data-mp="r0e7pl1qu7ji">
                                <span data-id="element-2596" data-mp="1jjbc657a4vhb">{`${user.skills} skills`}</span>
                                <span aria-hidden="true" data-id="element-2597" data-mp="1esbhz7pjorii">·</span>
                                <span className="truncate" data-id="element-2598" data-mp="1er0d14kd5dpt">{user.lastActive}</span>
                                {userType === 'learners' && 'department' in user && user.department && <>
                                    <span aria-hidden="true" data-id="element-2599" data-mp="1r32pziclqepd">·</span>
                                    <span className="truncate" data-id="element-2600" data-mp="1w1dztt2wcp7l">{user.department}</span>
                                  </>}
                              </div>
                            </div>
                          </div>
                        </td>
                        {userType === 'learners' && <td className="hidden md:table-cell py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600" data-id="element-2601" data-mp="2a16nffj4mpbc">
                            {'department' in user && user.department ? <span className="inline-flex max-w-[12rem] truncate rounded bg-[#30718D]/10 px-2 py-1 text-xs font-medium text-[#30718D]" title={user.department} data-id="element-2602" data-mp="2esomtz5i4hu7">{user.department}</span> : <span className="text-gray-400" data-id="element-2603" data-mp="2ordxp7yzd20y">—</span>}
                          </td>}
                        {userType === 'learners' && <td className="hidden lg:table-cell py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600" data-id="element-2604" data-mp="2tpxn5ics8vy2">
                            {'cohort' in user && user.cohort ? <span className="inline-flex max-w-[12rem] truncate rounded bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700" title={user.cohort} data-id="element-2605" data-mp="3a1jf8ipdbv5x">{user.cohort}</span> : <span className="text-gray-400" data-id="element-2606" data-mp="3nyybo7e1h37e">—</span>}
                          </td>}
                        <td className="py-3 sm:py-4 px-3 sm:px-6" data-id="element-2607" data-mp="3izv5gjmboqxu">
                          <div className="relative group/status inline-flex" data-id="element-2608" data-mp="2vdett6yxl5jg">
                            <span className={`inline-flex h-6 items-center justify-center rounded border bg-white px-3 text-xs font-bold whitespace-nowrap cursor-help ${user.status === 'active' ? 'border-[#5290A6] text-[#30718D]' : user.status === 'completed' ? 'border-[#05634B] text-[#05634B]' : user.status === 'pending' ? 'border-[#BFAF00] text-[#A16207]' : user.status === 'not_started' ? 'border-[#7E22CE] text-[#7E22CE]' : user.status === 'not_assigned' ? 'border-[#DB3725] text-[#DB3725]' : user.status === 'inactive' ? 'border-[#828282] text-[#6B7280]' : 'border-gray-300 text-gray-600'}`} data-id="element-2609" data-mp="2rbbh6f0izuwl">
                              {user.status === 'not_assigned' ? 'Not Assigned' : user.status === 'not_started' ? 'Not Started' : user.status.charAt(0).toUpperCase() + user.status.slice(1)}
                            </span>
                            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden w-56 px-3 py-2 bg-gray-900 text-white text-xs rounded-lg shadow-lg text-center opacity-0 invisible group-hover/status:opacity-100 group-hover/status:visible transition-all duration-150 z-50 pointer-events-none sm:block" data-id="element-2610" data-mp="j3ybp19gbnu2">
                              {user.status === 'not_assigned' && 'This learner has no skill modules or Pathways assigned to them.'}
                              {user.status === 'pending' && 'This learner has not completed their account registration. Send them a reminder email.'}
                              {user.status === 'not_started' && 'This learner has not started any skill modules or Pathways. Send them a reminder email.'}
                              {user.status === 'active' && 'This learner has accessed a skill module in the past 30 days.'}
                              {user.status === 'inactive' && 'This learner has not accessed a skill module in the past 30 days. Send them a reminder email.'}
                              {user.status === 'completed' && 'This learner completed all available skill modules and Pathways.'}
                              <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px border-4 border-transparent border-t-gray-900" data-id="element-2611" data-mp="3itzxx167opxc" />
                            </div>
                          </div>
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600 hidden sm:table-cell" data-id="element-2612" data-mp="394878i18ggy5">
                          {`${user.skills} skills`}
                        </td>
                        <td className="py-3 sm:py-4 px-3 sm:px-6 text-sm text-gray-600 hidden sm:table-cell" data-id="element-2613" data-mp="302gzl7n4u01n">
                          {user.lastActive}
                        </td>
                        <td className="py-3 sm:py-4 px-1 sm:px-6" data-id="element-2614" data-mp="2bj5gslg7d3vc">
                          <div className="flex items-center justify-center" data-id="element-2615" data-mp="2phn2yeqgm8b5">
                            <button type="button" onClick={() => setExpandedUserId(expandedUserId === user.id ? null : user.id)} aria-expanded={expandedUserId === user.id} aria-label={`${expandedUserId === user.id ? 'Hide' : 'Show'} details for ${user.name}`} className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-[#30718D]" data-id="element-2616" data-mp="2pfk2f0rokws6">
                              <ChevronDown size={18} aria-hidden="true" className={`transition-transform ${expandedUserId === user.id ? 'rotate-180' : ''}`} data-id="element-2617" data-mp="346sxhpecracp" />
                            </button>
                          </div>
                        </td>
                      </motion.tr>

                      {/* Expanded Row Details */}
                      <AnimatePresence data-id="element-2618" data-mp="2av4bi5sglywz">
                        {expandedUserId === user.id && <motion.tr initial={{
                      opacity: 0
                    }} animate={{
                      opacity: 1
                    }} exit={{
                      opacity: 0
                    }} transition={{
                      duration: 0.2
                    }} data-id="element-2619" data-mp="2fswcrqezuxdu">
                            <td colSpan={userType === 'learners' ? 8 : 6} className="bg-gray-50 px-4 sm:px-6 py-4 border-b border-gray-200" data-id="element-2620" data-mp="2tl2n2vvgua5d">
                              <motion.div initial={{
                          height: 0,
                          opacity: 0
                        }} animate={{
                          height: 'auto',
                          opacity: 1
                        }} exit={{
                          height: 0,
                          opacity: 0
                        }} transition={{
                          duration: 0.3
                        }} className="overflow-hidden" data-id="element-2621" data-mp="2yhsz9845glli">
                                <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-2622" data-mp="15ocu53y4924z">
                                  {/* Assigned Pathways */}
                                  <div className="pb-4 border-b border-gray-200" data-id="element-2623" data-mp="vwgvnrs4ba08">
                                    <p className="text-xs font-medium text-gray-500 mb-3" data-id="element-2624" data-mp="rvdk3hh3s04t">
                                      Assigned Pathways{' '}
                                      <span className="uppercase" data-id="element-2625" data-mp="1ol4ap5m9x35c">
                                        (
                                        {user.assignedPathways && user.assignedPathways.length > 0 ? `${user.assignedPathways.reduce((sum: number, name: string) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0)} SKILLS` : '0 SKILLS'}
                                        )
                                      </span>
                                    </p>
                                    {user.assignedPathways && user.assignedPathways.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-2626" data-mp="1n3nvd7782vju">
                                        {user.assignedPathways.map((pathway, idx) => <span key={idx} className="inline-flex items-center gap-2 px-2.5 py-1.5 bg-purple-50 rounded text-xs font-medium text-purple-700" data-id="element-2627" data-mp="1rudxmbkcqiab" data-mpi={idx}>
                                              <span className="text-[10px] font-bold uppercase tracking-wide" data-id="element-2628" data-mp="1i41g6s7u358e">
                                                Pathway
                                              </span>
                                              {pathway}
                                            </span>)}
                                      </div> : <p className="text-sm text-gray-400 italic" data-id="element-2629" data-mp="1ws5snegamkiq">
                                        No pathways assigned
                                      </p>}
                                  </div>

                                  {/* Assigned Skills */}
                                  <div className="pt-4" data-id="element-2630" data-mp="qdew1my7dlui">
                                    <p className="text-xs font-medium text-gray-500 mb-3" data-id="element-2631" data-mp="qb272pu12b7y">
                                      Assigned Skills{' '}
                                      <span className="uppercase" data-id="element-2632" data-mp="dthl4e3udnwz">
                                        (
                                        {user.assignedSkills ? user.assignedSkills.length : 0}{' '}
                                        SKILLS)
                                      </span>
                                    </p>
                                    {user.assignedSkills && user.assignedSkills.length > 0 ? <div className="flex flex-wrap gap-2" data-id="element-2633" data-mp="3qcz9zdumpz0c">
                                        {user.assignedSkills.map((skill, idx) => <span key={idx} className="px-2.5 py-1.5 bg-[#30718D]/10 rounded text-xs font-medium text-[#30718D]" data-id="element-2634" data-mp="8x0xdl0k1bkf" data-mpi={idx}>
                                              {skill}
                                            </span>)}
                                      </div> : <p className="text-sm text-gray-400 italic" data-id="element-2635" data-mp="37lpwyulngs40">
                                        No skills assigned
                                      </p>}
                                  </div>
                                </div>
                              </motion.div>
                            </td>
                          </motion.tr>}
                      </AnimatePresence>
                    </Fragment>)}
                </AnimatePresence>
              </tbody>
            </table>

            {/* Pagination */}
            {filteredUsers.length > 0 && totalPages > 1 && <div className="flex flex-col gap-2 border-t border-gray-200 px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:px-6" data-id="element-2636" data-mp="xiiry4x9m4kj">
                <p className="text-sm text-gray-600" data-id="element-2637" data-mp="11jcjr9dtw3ip">
                  Showing {(safeCurrentPage - 1) * itemsPerPage + 1}–
                  {Math.min(safeCurrentPage * itemsPerPage, filteredUsers.length)}{' '}
                  of {filteredUsers.length}
                </p>
                <div className="flex items-center gap-2" data-id="element-2638" data-mp="2hxuhvmiwchgi">
                  <span className="text-sm text-gray-600" data-id="element-2639" data-mp="2i0gonjxyqsxo">Page</span>
                  <div className="relative" ref={paginationDropdownRef} data-id="element-2640" data-mp="2s0znpycc7ukr">
                    <button type="button" onClick={() => setIsPaginationDropdownOpen(open => !open)} aria-haspopup="listbox" aria-expanded={isPaginationDropdownOpen} aria-label="Select page" className={`flex min-w-14 items-center justify-between rounded-md border bg-white py-1 pl-2 pr-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${isPaginationDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 text-[#30718D]' : 'border-gray-300 text-gray-700'}`} data-id="element-2641" data-mp="2n2y3ha36dp7p">
                      <span data-id="element-2642" data-mp="1zeojmdpivbj7">{safeCurrentPage}</span>
                      <ChevronDown size={14} aria-hidden="true" className={`ml-2 text-gray-400 transition-transform ${isPaginationDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2643" data-mp="1zfgfzqqy1daj" />
                    </button>
                    {isPaginationDropdownOpen && <div role="listbox" aria-label="Select page" className="absolute bottom-full z-30 mb-1 max-h-60 min-w-full overflow-y-auto overflow-x-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2644" data-mp="3ppjgw48wmvj5">
                        {Array.from({
                    length: totalPages
                  }, (_, i) => i + 1).map(page => <button key={page} type="button" role="option" aria-selected={safeCurrentPage === page} onClick={() => {
                    setCurrentPage(page);
                    setIsPaginationDropdownOpen(false);
                  }} className={`flex w-full items-center border-b border-gray-100 px-3 py-2 text-left text-sm transition-colors last:border-b-0 ${safeCurrentPage === page ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2645" data-mp="32u576kppns1">
                          {page}
                        </button>)}
                      </div>}
                  </div>
                  <span className="text-sm text-gray-600" data-id="element-2646" data-mp="1ek3jzfswbrn0">of {totalPages}</span>
                </div>
              </div>}
          </div>

          {filteredUsers.length === 0 && <div className="p-12 text-center" data-id="element-2647" data-mp="1tlahv21qqeev">
              <Users size={48} className="mx-auto text-gray-400 mb-4" data-id="element-2648" data-mp="1tm207b6bufn7" />
              <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-2649" data-mp="1ons8jajt9x6c">
                No users found
              </h3>
              <p className="text-gray-600" data-id="element-2650" data-mp="22ff2v4u70vmh">
                Try adjusting your search or filter criteria
              </p>
            </div>}
        </div>

        <SkillsOverview data-id="element-2651" data-mp="2cbs54r3t0hsu" />
      </div>

      {/* Add Admin Modal */}
      <AnimatePresence data-id="element-2652" data-mp="2ce4nv6hdyw6y">
        {showAddAdminModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={handleCloseAdminModal} data-id="element-2653" data-mp="27c5i5py6bn6u">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-2654" data-mp="2lavprzimd59g">
              <div className="flex items-center justify-between mb-6" data-id="element-2655" data-mp="3n1bwr8a907o8">
                <div className="flex items-center gap-3" data-id="element-2656" data-mp="3ib57r7btql5g">
                  <div className="w-10 h-10 rounded-full bg-[#30718D]/10 flex items-center justify-center" data-id="element-2657" data-mp="3i9kctglll072">
                    <Shield size={20} className="text-[#30718D]" data-id="element-2658" data-mp="3dbs9lqfi5rnk" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-2659" data-mp="39c1p24gkk7rh">
                    {adminModalStep === 'form' ? 'Add Admin' : 'Admin Added'}
                  </h2>
                </div>
                <button onClick={handleCloseAdminModal} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-2660" data-mp="2zd2c49ortpyo">
                  Close
                </button>
              </div>

              {adminModalStep === 'form' ? <>
                  <p className="text-sm text-gray-600 mb-6" data-id="element-2661" data-mp="slbdz8pv2con">
                    Provide the following information to add an additional
                    administrator account.
                  </p>

                  <div className="space-y-6 mb-6" data-id="element-2662" data-mp="153xalnt5hkgt">
                    {adminEntries.map((entry, index) => <div key={index} className="space-y-4" data-id="element-2663" data-mp="19vfas9ncnh0q" data-mpi={index}>
                        <h3 className="text-sm font-bold text-gray-900" data-id="element-2664" data-mp="19x8htq1vk399">
                          Admin {index + 1}
                        </h3>
                        <div className="grid grid-cols-2 gap-4" data-id="element-2665" data-mp="i4hktdcdaaiy">
                          <div data-id="element-2666" data-mp="i6c5cqjq80mi">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2667" data-mp="m51gsdl7f83i">
                              First Name{' '}
                              <span className="text-[#DB3725]" data-id="element-2668" data-mp="r3cnwgk474i1">*</span>
                            </label>
                            <input type="text" placeholder="Enter first name" value={entry.firstName} onChange={e => handleAdminEntryChange(index, 'firstName', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2669" data-mp="w522g66jq0av" />
                          </div>
                          <div data-id="element-2670" data-mp="1cw72mk7vwd0x">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2671" data-mp="1cv5mw2fxb2cv">
                              Last Name{' '}
                              <span className="text-[#DB3725]" data-id="element-2672" data-mp="1mtv6q0rdqwvr">*</span>
                            </label>
                            <input type="text" placeholder="Enter last name" value={entry.lastName} onChange={e => handleAdminEntryChange(index, 'lastName', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2673" data-mp="z40vfnmplgdm" />
                          </div>
                        </div>
                        <div data-id="element-2674" data-mp="141ak3129xo0e">
                          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2675" data-mp="gd9dvyskijo5">
                            Email <span className="text-[#DB3725]" data-id="element-2676" data-mp="bey6rvtnqn9m">*</span>
                          </label>
                          <input type="email" placeholder="Enter email address" value={entry.email} onChange={e => handleAdminEntryChange(index, 'email', e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" data-id="element-2677" data-mp="2n1ji9fxx5jeq" />
                        </div>
                      </div>)}
                  </div>

                  <div className="mb-6" data-id="element-2678" data-mp="35sstpur92i8y">
                    <label className="flex items-start gap-3 cursor-pointer" data-id="element-2679" data-mp="35t2jbh8dune4">
                      <input type="checkbox" checked={adminAcknowledge} onChange={e => setAdminAcknowledge(e.target.checked)} className="w-4 h-4 mt-0.5 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-2680" data-mp="3aqkuzfdsbgpt" />
                      <span className="text-sm text-gray-700 leading-snug" data-id="element-2681" data-mp="30s50d2fjtpbk">
                        <span className="text-[#DB3725]" data-id="element-2682" data-mp="1lcg0iuuugn5t">*</span> I acknowledge
                        that I have the authority to share the information of
                        the learners I provided.
                      </span>
                    </label>
                  </div>

                  <div className="flex gap-3 mb-6" data-id="element-2683" data-mp="20u7a86aeyrh8">
                    <button onClick={handleAddAdminEntry} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2684" data-mp="20tedly565ict">
                      Add another
                    </button>
                    <button onClick={handleAdminSubmit} disabled={!adminAcknowledge || !adminEntries.every(e => e.firstName && e.lastName && e.email)} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${adminAcknowledge && adminEntries.every(e => e.firstName && e.lastName && e.email) ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-2685" data-mp="2okti9xkf4br8">
                      Submit
                    </button>
                  </div>

                  <div className="space-y-3 border-t border-gray-200 pt-4" data-id="element-2686" data-mp="z5lqam9nghic">
                    <p className="text-gray-500 text-xs leading-relaxed" data-id="element-2687" data-mp="z7q0fly56cr2">
                      New admins will have all the same capabilities you
                      currently have, including registering employees for
                      training, monitoring learning progress, adding additional
                      administrator accounts and purchasing¹ more training to be
                      distributed through this License Management interface.
                    </p>
                    <p className="text-gray-400 text-xs" data-id="element-2688" data-mp="3tlay5ziik4lr">
                      ¹ Payment information is never saved or stored and all
                      admins will have to enter new payment information when
                      purchasing additional training content.
                    </p>
                  </div>
                </> : <div className="py-8 text-center flex flex-col items-center" data-id="element-2689" data-mp="285vhh8oiwulx">
                  <div className="w-16 h-16 bg-[#007558]/10 rounded-full flex items-center justify-center mb-6" data-id="element-2690" data-mp="287yhmlje444d">
                    <CheckCircle size={32} className="text-[#007558]" data-id="element-2691" data-mp="3gfukowlea0v5" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-2692" data-mp="3ghp3a4971gw2">
                    You've added an additional admin
                  </h3>
                  <p className="text-gray-600 text-sm max-w-sm mx-auto" data-id="element-2693" data-mp="3phllpo4zpjio">
                    We'll send an email to the address you provided with more
                    information on how to create a B2B admin account.
                  </p>
                </div>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Add Individual User Modal */}
      <AnimatePresence data-id="element-2694" data-mp="c1eb6v5w6yml">
        {showAddModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={() => {
        setShowAddModal(false);
        setDepartment('');
        setCohort('');
        setNewDepartmentName('');
        setNewCohortName('');
      }} data-id="element-2695" data-mp="c0co1sblqloi">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-md w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-2696" data-mp="h1sb1pxcb29j">
              <div className="flex items-center justify-between mb-6" data-id="element-2697" data-mp="vluzhi5hshsy">
                <div className="flex items-center gap-3" data-id="element-2698" data-mp="hvrlfegrnuel">
                  <div className="w-10 h-10 rounded-full bg-[#30718D]/10 flex items-center justify-center" data-id="element-2699" data-mp="hu6qhnqji9g7">
                    <UserPlus size={20} className="text-[#30718D]" data-id="element-2700" data-mp="7xv60agsqdao" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-2701" data-mp="cwy2v7mmhd7k">
                    {addModalStep === 'form' ? `Add Learner` : 'Confirm Registration'}
                  </h2>
                </div>
                <button onClick={() => {
              setShowAddModal(false);
              setIsLicenseDropdownOpen(false);
              setLicenseSearch('');
              setDepartment('');
              setCohort('');
              setNewDepartmentName('');
              setNewCohortName('');
              setAddModalStep('form');
              setAcknowledgeChecked(false);
              setSelectedModalPathways([]);
              setSelectedLicenses([]);
            }} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-2702" data-mp="2yr13w0wn1q5">
                  Close
                </button>
              </div>

              {addModalStep === 'form' ? <>
                  <div className="space-y-4 mb-6" data-id="element-2703" data-mp="3rs8gd7dvfi6x">
                    <div data-id="element-2704" data-mp="3mw1htznt18z0">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2705" data-mp="3mv9o6udrplbd">
                        First Name <span className="text-[#DB3725]" data-id="element-2706" data-mp="3hxqabvkzfajy">*</span>
                      </label>
                      <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter first name" data-id="element-2707" data-mp="3cw0xcae78mt8" />
                    </div>
                    <div data-id="element-2708" data-mp="1scylbeqhrd4y">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2709" data-mp="1xduwmdd6a1ke">
                        Last Name <span className="text-[#DB3725]" data-id="element-2710" data-mp="22cxr53vj0pe4">*</span>
                      </label>
                      <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter last name" data-id="element-2711" data-mp="22al9ysxlej24" />
                    </div>
                    <div data-id="element-2712" data-mp="1elk2b7wl3bxw">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2713" data-mp="1jeljxno6dpl6">
                        Email Address <span className="text-[#DB3725]" data-id="element-2714" data-mp="lzhe7o16uebr">*</span>
                      </label>
                      <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#30718D] focus:border-transparent" placeholder="Enter email address" data-id="element-2715" data-mp="qx93096jdkbq" />
                    </div>
                    <div data-id="element-2716" data-mp="15phfyjm5h7sr">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2717" data-mp="15p7pyw13v0n2">
                        Department <span className="text-[#DB3725]" data-id="element-2718" data-mp="1apvftedllbfp">*</span>
                      </label>
                      <div className="relative" ref={departmentDropdownRef} data-id="element-2719" data-mp="1epnnlov63dk0">
                        <button type="button" onClick={() => {
                    setIsDepartmentDropdownOpen(open => !open);
                    setIsCreatingDepartment(false);
                  }} aria-haspopup="listbox" aria-expanded={isDepartmentDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-4 py-2 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isDepartmentDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2720" data-mp="1jpa17zewqvtc">
                          <span className={department ? 'text-gray-700' : 'text-gray-400'} data-id="element-2721" data-mp="3iwqifcni861c">{department || 'Select a department'}</span>
                          <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isDepartmentDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2722" data-mp="3dwuhjma3suq0" />
                        </button>
                        {isDepartmentDropdownOpen && <div role="listbox" aria-label="Select learner department" className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2723" data-mp="aj00454hbu03">
                            {departments.map(item => <button key={item} type="button" role="option" aria-selected={department === item} onClick={() => {
                      setDepartment(item);
                      setIsDepartmentDropdownOpen(false);
                    }} className={`flex w-full items-center border-b border-gray-100 px-4 py-2.5 text-left text-sm transition-colors ${department === item ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2724" data-mp="3rxex89kq2afa">
                              {item}
                            </button>)}
                            <div className="border-t border-gray-200 bg-gray-50 p-2" data-id="element-2725" data-mp="28xxqqufjzsly">
                              {isCreatingDepartment ? <div className="flex gap-2" data-id="element-2726" data-mp="2dvzcxo8a081n">
                                  <input autoFocus value={newDepartmentName} onChange={event => setNewDepartmentName(event.target.value)} onKeyDown={event => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            handleCreateDepartment();
                          }
                        }} placeholder="New department name" className="min-w-0 flex-1 rounded-md border border-gray-300 px-2.5 py-2 text-sm focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-2727" data-mp="1z09x67toor5d" />
                                  <button type="button" onClick={handleCreateDepartment} disabled={!newDepartmentName.trim()} className="rounded-md bg-[#30718D] px-3 text-sm font-semibold text-white transition-colors hover:bg-[#265A70] disabled:cursor-not-allowed disabled:opacity-40" data-id="element-2728" data-mp="3b05hwlqwikk">Add</button>
                                </div> : <button type="button" onClick={() => setIsCreatingDepartment(true)} className="w-full rounded-md px-2.5 py-2 text-left text-sm font-semibold text-[#30718D] transition-colors hover:bg-[#D9EEF2]" data-id="element-2729" data-mp="7cv42tcakhun">
                                  + Create new department
                                </button>}
                            </div>
                          </div>}
                      </div>
                    </div>
                    <div data-id="element-2730" data-mp="r1vrgd3isjjw">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2731" data-mp="2wu2jhtb3w27s">
                        Cohort <span className="font-normal text-gray-400" data-id="element-2732" data-mp="2wvvqj9pmsogb">(optional)</span>
                      </label>
                      <div className="relative" ref={cohortDropdownRef} data-id="element-2733" data-mp="2u9wfxmqemdrr">
                        <button type="button" onClick={() => {
                    setIsCohortDropdownOpen(open => !open);
                    setIsCreatingCohort(false);
                  }} aria-haspopup="listbox" aria-expanded={isCohortDropdownOpen} className={`flex w-full items-center justify-between rounded-lg border bg-white px-4 py-2 text-left text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-[#30718D] ${isCohortDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20' : 'border-gray-300 text-gray-700'}`} data-id="element-2734" data-mp="2ubqqc741unhl">
                          <span className={cohort ? 'text-gray-700' : 'text-gray-400'} data-id="element-2735" data-mp="2kirzsjozsmvc">{cohort || 'Select a cohort'}</span>
                          <ChevronDown size={16} aria-hidden="true" className={`ml-2 flex-shrink-0 text-gray-400 transition-transform ${isCohortDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2736" data-mp="2pbuly6rfwu1i" />
                        </button>
                        {isCohortDropdownOpen && <div role="listbox" aria-label="Select learner cohort" className="absolute z-20 mt-1 w-full overflow-hidden rounded-lg border border-gray-200 bg-white shadow-lg" data-id="element-2737" data-mp="1paheuuccwwws">
                            <button type="button" role="option" aria-selected={!cohort} onClick={() => {
                      setCohort('');
                      setIsCohortDropdownOpen(false);
                    }} className={`flex w-full items-center px-4 py-2.5 text-left text-sm transition-colors border-b border-gray-100 ${!cohort ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2738" data-mp="1fcjre92bn458">
                              No cohort
                            </button>
                            {cohorts.map(item => <button key={item} type="button" role="option" aria-selected={cohort === item} onClick={() => {
                      setCohort(item);
                      setIsCohortDropdownOpen(false);
                    }} className={`flex w-full items-center px-4 py-2.5 text-left text-sm transition-colors border-b border-gray-100 ${cohort === item ? 'bg-[#30718D]/10 font-medium text-[#30718D]' : 'text-gray-700 hover:bg-gray-50'}`} data-id="element-2739" data-mp="rnqtw861wo8i">
                              {item}
                            </button>)}
                            <div className="border-t border-gray-200 bg-gray-50 p-2" data-id="element-2740" data-mp="3v7zpvkvt37e0">
                              {isCreatingCohort ? <div className="flex gap-2" data-id="element-2741" data-mp="41om3gzevsiz">
                                  <input autoFocus value={newCohortName} onChange={event => setNewCohortName(event.target.value)} onKeyDown={event => {
                          if (event.key === 'Enter') {
                            event.preventDefault();
                            handleCreateCohort();
                          }
                        }} placeholder="New cohort name" className="min-w-0 flex-1 rounded-md border border-gray-300 px-2.5 py-2 text-sm focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20" data-id="element-2742" data-mp="rqhifejy42e4" />
                                  <button type="button" onClick={handleCreateCohort} disabled={!newCohortName.trim()} className="rounded-md bg-[#30718D] px-3 text-sm font-semibold text-white transition-colors hover:bg-[#265A70] disabled:cursor-not-allowed disabled:opacity-40" data-id="element-2743" data-mp="304mqb24vkfsd">Add</button>
                                </div> : <button type="button" onClick={() => setIsCreatingCohort(true)} className="w-full rounded-md px-2.5 py-2 text-left text-sm font-semibold text-[#30718D] transition-colors hover:bg-[#D9EEF2]" data-id="element-2744" data-mp="34vctq9tqq8kf">
                                  + Create new cohort
                                </button>}
                            </div>
                          </div>}
                      </div>
                    </div>
                    <div data-id="element-2745" data-mp="2l73xnop2tifn">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2746" data-mp="2l9zzvp7yit9w">
                        Licenses
                      </label>
                      <div className="relative" ref={licenseDropdownRef} data-id="element-2747" data-mp="ifxrr8if39y">
                        <div className={`w-full px-4 py-2 border rounded-lg bg-white flex items-center justify-between cursor-text ${isLicenseDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]' : 'border-gray-300'}`} onClick={() => setIsLicenseDropdownOpen(true)} data-id="element-2748" data-mp="kk11covhgnwo">
                          <input type="text" placeholder={selectedLicenses.length + selectedModalPathways.length > 0 ? `${selectedLicenses.length + selectedModalPathways.length} item${selectedLicenses.length + selectedModalPathways.length > 1 ? 's' : ''} selected — type to search...` : 'Search and select pathways or modules'} value={licenseSearch} onChange={e => {
                      setLicenseSearch(e.target.value);
                      if (!isLicenseDropdownOpen) setIsLicenseDropdownOpen(true);
                    }} onFocus={() => setIsLicenseDropdownOpen(true)} className="flex-1 text-sm bg-transparent outline-none placeholder-gray-400" data-id="element-2749" data-mp="ticr6ooizho2" />
                          <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isLicenseDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2750" data-mp="3j0mxhwknx4h4" />
                        </div>
                        {isLicenseDropdownOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-hidden" data-id="element-2751" data-mp="36qdrkz6y8pq3">
                            <div className="max-h-72 overflow-y-auto" data-id="element-2752" data-mp="2xqh3ayoh1svk">
                              {/* Pathways Section */}
                              {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).length > 0 && <>
                                  <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2753" data-mp="3pig8mbni680v">
                                    <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-2754" data-mp="3ggyvn25e6mge">
                                      Pathways
                                    </span>
                                    <button type="button" onClick={e => {
                            e.stopPropagation();
                            selectAllModalPathways();
                          }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-2755" data-mp="251tguzrzkxgf">
                                      {selectedModalPathways.length === pathwayData.length ? 'Deselect all' : 'Select all'}
                                    </button>
                                  </div>
                                  {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-2756" data-mp="1h1ka93l10ju7">
                                        <input type="checkbox" checked={selectedModalPathways.includes(pathway.name)} onChange={() => toggleModalPathway(pathway.name)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-2757" data-mp="1v0jywb8jgyqd" />
                                        <div data-id="element-2758" data-mp="3ruetb5gucjcb">
                                          <div className="text-sm font-semibold text-gray-900" data-id="element-2759" data-mp="3rvg89l0z9pzb">
                                            {pathway.name}
                                          </div>
                                          <div className="text-xs text-gray-500" data-id="element-2760" data-mp="2ccrz7t00l027">
                                            {pathway.skillCount} skills
                                          </div>
                                        </div>
                                      </label>)}
                                </>}

                              {/* Individual Skills Section */}
                              {availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).length > 0 && <>
                                  <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2761" data-mp="1jlqelcdjycba">
                                    <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-2762" data-mp="39zh5wg5nw0ue">
                                      Individual Skills
                                    </span>
                                    <button type="button" onClick={e => {
                            e.stopPropagation();
                            selectAllModalSkills();
                          }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-2763" data-mp="qsd9itjj8sw4">
                                      {selectedLicenses.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                                    </button>
                                  </div>
                                  {availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-2764" data-mp="10o6r4rc3zckr">
                                        <input type="checkbox" checked={selectedLicenses.includes(skill)} onChange={() => toggleLicense(skill)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-2765" data-mp="1t73ypkcxygms" />
                                        <span className="text-sm text-gray-700" data-id="element-2766" data-mp="1vsbevzub4zmn">
                                          {skill}
                                        </span>
                                      </label>)}
                                </>}

                              {pathwayData.filter(p => p.name.toLowerCase().includes(licenseSearch.toLowerCase())).length === 0 && availableSkills.filter(skill => skill.toLowerCase().includes(licenseSearch.toLowerCase())).length === 0 && <p className="px-4 py-3 text-sm text-gray-400" data-id="element-2767" data-mp="2jnnu3wi2jc9c">
                                    No results found
                                  </p>}
                            </div>
                          </div>}
                      </div>
                      {(selectedModalPathways.length > 0 || selectedLicenses.length > 0) && <div className="flex flex-wrap gap-1.5 mt-2 max-h-24 overflow-y-auto" data-id="element-2768" data-mp="2xhf8pjanpmbx">
                          {selectedModalPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-2769" data-mp="2os6uhrgv4ryv">
                              <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-2770" data-mp="2kq3gav2t799w">
                                Pathway
                              </span>
                              {pathway}
                              <button type="button" onClick={() => toggleModalPathway(pathway)} className="hover:text-[#DB3725] transition-colors" data-id="element-2771" data-mp="2tl9g9dfeex4i">
                                ×
                              </button>
                            </span>)}
                          {selectedLicenses.map(skill => <span key={skill} className="inline-flex items-center gap-1 px-2 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-2772" data-mp="2fpfh3m4ffm4l">
                              {skill}
                              <button type="button" onClick={() => toggleLicense(skill)} className="hover:text-[#DB3725] transition-colors" data-id="element-2773" data-mp="3r8rydeuy9bl6">
                                ×
                              </button>
                            </span>)}
                        </div>}
                    </div>
                  </div>

                  <div className="flex gap-3" data-id="element-2774" data-mp="yz4xl3pdziyj">
                    <button onClick={() => {
                setShowAddModal(false);
                setIsLicenseDropdownOpen(false);
                setDepartment('');
                setCohort('');
                setNewDepartmentName('');
                setNewCohortName('');
                setAddModalStep('form');
                setAcknowledgeChecked(false);
                setSelectedModalPathways([]);
                setSelectedLicenses([]);
              }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2775" data-mp="z0g6tj1lpix1">
                      Cancel
                    </button>
                    <button onClick={() => {
                setIsLicenseDropdownOpen(false);
                setLicenseSearch('');
                setAddModalStep('confirm');
              }} disabled={!firstName.trim() || !lastName.trim() || !email.trim() || !department} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${firstName.trim() && lastName.trim() && email.trim() && department ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-2776" data-mp="2fd4sg09dkiex">
                      Next
                    </button>
                  </div>
                </> : <>
                  {/* Confirmation Screen */}
                  <p className="text-sm text-gray-600 mb-4" data-id="element-2777" data-mp="21hpsaddhon30">
                    Please ensure all learner information provided is accurate.
                  </p>

                  <div className="flex items-center gap-4 text-xs mb-4" data-id="element-2778" data-mp="1rmxtx7c31w76">
                    {(() => {
                const totalPathwaySkills = selectedModalPathways.reduce((sum, name) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0);
                const totalSkills = totalPathwaySkills + selectedLicenses.length;
                return <>
                          <span className="text-gray-500" data-id="element-2779" data-mp="23y6mxdfsngr">
                            Licenses to be registered:{' '}
                            <span className="font-bold text-[#30718D]" data-id="element-2780" data-mp="74lz7nhbdcd3">
                              {totalSkills}
                            </span>
                          </span>
                          <span className="text-gray-300" data-id="element-2781" data-mp="3al2gei3l7oao">|</span>
                          <span className="text-gray-500" data-id="element-2782" data-mp="3aigd4unqbuy9">
                            Remaining:{' '}
                            <span className="font-bold text-gray-900" data-id="element-2783" data-mp="3kigwuhpigd2z">
                              {190 - totalSkills}
                            </span>
                          </span>
                        </>;
              })()}
                  </div>

                  <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 mb-5" data-id="element-2784" data-mp="2rt04tl5syy7a">
                    <div className="flex items-center gap-3 mb-3" data-id="element-2785" data-mp="2wrla3yzww82l">
                      <div className="w-10 h-10 rounded-full bg-[#30718D] flex items-center justify-center text-white text-sm font-bold" data-id="element-2786" data-mp="1q522q3wukeg9">
                        {firstName.charAt(0).toUpperCase()}
                        {lastName.charAt(0).toUpperCase()}
                      </div>
                      <div data-id="element-2787" data-mp="1u75gx0awhx58">
                        <p className="text-sm font-semibold text-gray-900" data-id="element-2788" data-mp="1u6vypyw3kua3">
                          {firstName} {lastName}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-2789" data-mp="29239nu9yoomu">{email}</p>
                        <div className="mt-1 flex flex-wrap gap-1.5" data-id="element-2790" data-mp="244tnqols6v3r">
                          <span className="text-xs font-medium text-[#30718D]" data-id="element-2791" data-mp="2hwztrhv7zlph">{department}</span>
                          {cohort && <span className="rounded bg-purple-50 px-1.5 py-0.5 text-xs font-medium text-purple-700" data-id="element-2792" data-mp="2dw7jqmeixcs5">{cohort}</span>}
                        </div>
                      </div>
                    </div>

                    {selectedModalPathways.length > 0 && <div className="pt-3 border-t border-gray-200" data-id="element-2793" data-mp="2mtzz1qk8wkfj">
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-2794" data-mp="36i5ynlp5qg1g">
                          Assigned Pathways (
                          {selectedModalPathways.reduce((sum, name) => sum + (pathwayData.find(p => p.name === name)?.skillCount || 0), 0)}{' '}
                          skills)
                        </p>
                        <div className="flex flex-wrap gap-1.5" data-id="element-2795" data-mp="2nreq2mczuto4">
                          {selectedModalPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2.5 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-2796" data-mp="2shleal3lgc5u">
                              <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-2797" data-mp="2dquk56ej50zk">
                                Pathway
                              </span>
                              {pathway}
                            </span>)}
                        </div>
                      </div>}

                    {selectedLicenses.length > 0 && <div className={`pt-3 ${selectedModalPathways.length > 0 ? 'mt-3' : ''} border-t border-gray-200`} data-id="element-2798" data-mp="27xraz7dssadn">
                        <p className="text-xs font-medium text-gray-500 uppercase mb-2" data-id="element-2799" data-mp="23uck1lobm9lf">
                          Assigned Skills ({selectedLicenses.length})
                        </p>
                        <div className="flex flex-wrap gap-1.5" data-id="element-2800" data-mp="1tyrljxignrgf">
                          {selectedLicenses.map(skill => <span key={skill} className="px-2.5 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-2801" data-mp="2rkgn9rxlk7bw">
                              {skill}
                            </span>)}
                        </div>
                      </div>}
                  </div>

                  <div className="bg-amber-50 rounded-lg p-4 mb-5 border border-amber-100" data-id="element-2802" data-mp="2cxdq5md6s0p3">
                    <p className="text-sm text-gray-700 leading-relaxed" data-id="element-2803" data-mp="3achvhkw9h9xz">
                      Once you click submit, the learner will receive an email
                      with instructions to create a password and complete their
                      registration.
                    </p>
                  </div>

                  <label className="flex items-start gap-3 mb-6 cursor-pointer" data-id="element-2804" data-mp="3hwk2nplr0nt1">
                    <input type="checkbox" checked={acknowledgeChecked} onChange={e => setAcknowledgeChecked(e.target.checked)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D] mt-0.5" data-id="element-2805" data-mp="3mu2cdi7lb723" />
                    <span className="text-sm text-gray-700" data-id="element-2806" data-mp="3vu8oaznn3yz5">
                      I acknowledge that I have the authority to share the
                      information of the learner I provided.
                    </span>
                  </label>

                  <div className="flex gap-3" data-id="element-2807" data-mp="9i1pxakv4k33">
                    <button onClick={() => setAddModalStep('form')} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2808" data-mp="edqq9g4pi50g">
                      Back
                    </button>
                    <button onClick={handleAddUser} disabled={!acknowledgeChecked} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${acknowledgeChecked ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-2809" data-mp="nd42ggk7t7ov">
                      Submit
                    </button>
                  </div>
                </>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Bulk Upload Modal */}
      <AnimatePresence data-id="element-2810" data-mp="334rbnsq03z3k">
        {showBulkModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={handleCloseBulkModal} data-id="element-2811" data-mp="2y7rg4bqs2eqp">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 w-full shadow-2xl max-h-[90vh] overflow-y-auto max-w-lg" onClick={e => e.stopPropagation()} data-id="element-2812" data-mp="3c5zb4e4975z8">
              <div className="flex items-center justify-between mb-6" data-id="element-2813" data-mp="13q3gyqgy9xuw">
                <div className="flex items-center gap-3" data-id="element-2814" data-mp="17oj896k2dse4">
                  <div className="w-10 h-10 rounded-full bg-[#007558]/10 flex items-center justify-center" data-id="element-2815" data-mp="typlcts4di71">
                    <Upload size={20} className="text-[#007558]" data-id="element-2816" data-mp="yvz6vyce19pl" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-2817" data-mp="jzgsy5cwkbms">
                    Bulk Upload Learners
                  </h2>
                </div>
                <button onClick={handleCloseBulkModal} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-2818" data-mp="owqgffgqed7z">
                  Close
                </button>
              </div>

              {bulkUploadStep === 'upload' ? <>
                  <div className="mb-6" data-id="element-2819" data-mp="25dmb65w4obfg">
                    <div onClick={handleSimulateBulkUpload} className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-[#30718D] transition-colors cursor-pointer" data-id="element-2820" data-mp="2ac5xi7emvp8c">
                      <Upload size={48} className="mx-auto text-gray-400 mb-4" data-id="element-2821" data-mp="5attrvh652wq" />
                      <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-2822" data-mp="58qsugeh9pd8">
                        Click to upload or drag and drop
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-2823" data-mp="3sehsuxvsn2d5">
                        CSV file with columns: First Name, Last Name, Email, Department
                      </p>
                    </div>
                  </div>

                  <div className="bg-[#30718D]/5 rounded-lg p-4 mb-6" data-id="element-2824" data-mp="3io5clhv0hvct">
                    <div className="flex items-start gap-3" data-id="element-2825" data-mp="3dromii4956x3">
                      <AlertCircle size={20} className="text-[#30718D] mt-0.5" data-id="element-2826" data-mp="38rk58pvis85t" />
                      <div data-id="element-2827" data-mp="38ph5vf8h92of">
                        <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-2828" data-mp="34pp35j5rlqqz">
                          CSV Format Requirements
                        </p>
                        <p className="text-xs text-gray-600" data-id="element-2829" data-mp="2zrnkv0g5xvgk">
                          Your CSV must include headers: First Name, Last Name,
                          Email, Department. Each row represents one learner.
                        </p>
                      </div>
                    </div>
                  </div>

                  <button onClick={handleDownloadCsvTemplate} className="w-full mb-3 px-4 py-2 border border-[#30718D] bg-white text-[#30718D] rounded-lg hover:bg-[#30718D]/5 transition-colors font-medium flex items-center justify-center gap-2" data-id="element-2830" data-mp="1o7onmwklaf0z">
                    <Download size={16} data-id="element-2831" data-mp="10kyqa8j6r8mp" />
                    Download CSV Template
                  </button>

                  <div className="flex gap-3" data-id="element-2832" data-mp="15i8fpo6krkaj">
                    <button onClick={handleCloseBulkModal} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2833" data-mp="1a9qec5l4l8sc">
                      Cancel
                    </button>
                    <button onClick={handleSimulateBulkUpload} className="flex-1 px-4 py-2 bg-[#DB3725] text-white rounded-lg hover:bg-[#c02f1f] transition-colors font-medium shadow-sm" data-id="element-2834" data-mp="hs4lu8j6uywq">
                      Upload & Import
                    </button>
                  </div>
                </> : <>
                  <div className="bg-[#DB3725]/5 border border-[#DB3725]/20 rounded-lg p-4 mb-6" data-id="element-2835" data-mp="1tvdc8xeo11t5">
                    <p className="text-sm text-[#DB3725] font-medium" data-id="element-2836" data-mp="1pwcw5mnkod9u">
                      {bulkErrorEntries.length} learner(s) have validation
                      errors. Please correct the errors below and click "Fix &
                      Add" for each learner.
                    </p>
                  </div>

                  <div className="space-y-4 mb-6" data-id="element-2837" data-mp="1b7gpnu15z8bc">
                    {bulkErrorEntries.map(entry => <div key={entry.id} className="border border-gray-200 rounded-lg p-4 bg-white" data-id="element-2838" data-mp="166ayi0n5jt3x">
                        <div className="flex items-center justify-between mb-4" data-id="element-2839" data-mp="2mjra9d5r7y4p">
                          <h3 className="font-bold text-gray-900" data-id="element-2840" data-mp="2hl7nxbn90kbt">
                            Row {entry.row}
                          </h3>
                          <div className="flex items-center gap-2" data-id="element-2841" data-mp="2q5cmrxt0btz8">
                            {entry.fixed && <span className="flex items-center gap-1 text-sm font-medium text-[#007558] px-3 py-1.5 bg-[#007558]/10 rounded-md" data-id="element-2842" data-mp="2u6694mqsx0q0">
                                <CheckCircle size={16} data-id="element-2843" data-mp="2l3n8886ksy6e" />
                                Fixed
                              </span>}
                            <button onClick={() => handleRemoveBulkError(entry.id)} className="px-3 py-1.5 bg-[#DB3725] text-white text-sm font-medium rounded-md hover:bg-[#c02f1f] transition-colors" data-id="element-2844" data-mp="38v2g0gh4g7p1">
                              Remove
                            </button>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-2845" data-mp="340y9tzfok3p0">
                          <div data-id="element-2846" data-mp="3rranlqxlwuni">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2847" data-mp="dxw42x9bqhe">
                              First Name
                            </label>
                            <input type="text" value={entry.firstName} onChange={e => handleBulkErrorChange(entry.id, 'firstName', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.firstName ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-2848" data-mp="1widpdcu954fw" />
                            {entry.errors?.firstName && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-2849" data-mp="2agu5fue087ap">
                                <X size={12} data-id="element-2850" data-mp="26f8jzknemkow" /> {entry.errors.firstName}
                              </p>}
                          </div>
                          <div data-id="element-2851" data-mp="21f43vvqerrz7">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2852" data-mp="21fw1fc3kfzs4">
                              Last Name
                            </label>
                            <input type="text" value={entry.lastName} onChange={e => handleBulkErrorChange(entry.id, 'lastName', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.lastName ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-2853" data-mp="pzyy2iuzddbd" />
                            {entry.errors?.lastName && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-2854" data-mp="3fh1u65fbjmxy">
                                <X size={12} data-id="element-2855" data-mp="3keljq1hgvm57" /> {entry.errors.lastName}
                              </p>}
                          </div>
                          <div className="sm:col-span-2" data-id="element-2856" data-mp="3ud1au4ghuvep">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2857" data-mp="3udj3kr3y6rhv">
                              Email
                            </label>
                            <input type="email" value={entry.email} onChange={e => handleBulkErrorChange(entry.id, 'email', e.target.value)} disabled={entry.fixed} className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#30718D] text-sm ${entry.errors?.email ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'bg-gray-50 text-gray-500' : ''}`} data-id="element-2858" data-mp="1zzry83snits8" />
                            {entry.errors?.email && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-2859" data-mp="1gmqgnkhw9neb">
                                <X size={12} data-id="element-2860" data-mp="1koc0jpsuj1y0" /> {entry.errors.email}
                              </p>}
                          </div>
                          <div className="sm:col-span-2" data-id="element-2861" data-mp="28do68foysrvk">
                            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2862" data-mp="2dc7xmvmbuvvb">
                              Department
                            </label>
                            <div className="relative" data-id="element-2863" data-mp="24b9t8c7z8mc7">
                              <select value={entry.department || ''} onChange={e => handleBulkErrorChange(entry.id, 'department', e.target.value)} disabled={entry.fixed} className={`w-full appearance-none rounded-md border bg-white py-2 pl-3 pr-9 text-sm transition-colors focus:border-[#30718D] focus:outline-none focus:ring-2 focus:ring-[#30718D]/20 ${entry.errors?.department ? 'border-[#DB3725]' : 'border-gray-300'} ${entry.fixed ? 'cursor-not-allowed bg-gray-50 text-gray-500' : 'text-gray-700'}`} data-id="element-2864" data-mp="249qa8duxrx6q">
                                <option value="" data-id="element-2865" data-mp="ucie9ol1d8qs">Select a department</option>
                                {departments.map(item => <option key={item} value={item} data-id="element-2866" data-mp="pf01fn3we9di">{item}</option>)}
                              </select>
                              <ChevronDown size={16} aria-hidden="true" className={`pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 ${entry.fixed ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-2867" data-mp="1m9s7lndq46x" />
                            </div>
                            {entry.errors?.department && <p className="text-[#DB3725] text-xs mt-1 flex items-center gap-1" data-id="element-2868" data-mp="6mxl6cv64v3s">
                                <X size={12} data-id="element-2869" data-mp="3f27pzsqg0ef9" /> {entry.errors.department}
                              </p>}
                          </div>
                        </div>
                      </div>)}
                    {bulkErrorEntries.length === 0 && <div className="text-center py-8 text-gray-500" data-id="element-2870" data-mp="1dz6wwki3yisu">
                        All errors resolved. You can now submit.
                      </div>}
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-200" data-id="element-2871" data-mp="1nrw5n7m9xikh">
                    <button onClick={() => setBulkUploadStep('upload')} className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2872" data-mp="1rrwi4mptbjow">
                      Cancel
                    </button>
                    <button onClick={handleSubmitBulkErrors} className="px-6 py-2 bg-[#111827] text-white rounded-lg hover:bg-gray-800 transition-colors font-medium shadow-sm" data-id="element-2873" data-mp="142lqpvucr1nf">
                      Submit All (
                      {bulkErrorEntries.filter(e => e.fixed || Object.keys(e.errors || {}).length === 0).length}
                      )
                    </button>
                  </div>
                </>}
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Generate Link Modal */}
      <AnimatePresence data-id="element-2874" data-mp="2pn8mo4cgbfvq">
        {showLinkModal && <div className="fixed inset-0 bg-black bg-opacity-60 z-50 flex items-center justify-center p-4" onClick={() => setShowLinkModal(false)} data-id="element-2875" data-mp="2poa9f62txqta">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} exit={{
          opacity: 0,
          scale: 0.95
        }} transition={{
          type: 'spring',
          stiffness: 300,
          damping: 30
        }} className="bg-white rounded-xl p-6 max-w-lg w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-2876" data-mp="2guowlsa86jmi">
              <div className="flex items-center justify-between mb-6" data-id="element-2877" data-mp="1xw2rm2bl88db">
                <div className="flex items-center gap-3" data-id="element-2878" data-mp="5rtcf5v9et9">
                  <div className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center" data-id="element-2879" data-mp="35l0db5iv9z">
                    <Link2 size={20} className="text-purple-600" data-id="element-2880" data-mp="3s77tp2710cqj" />
                  </div>
                  <h2 className="text-xl font-bold text-gray-900" data-id="element-2881" data-mp="34ry6wvxj6v9">
                    Learner Registration Link Generated
                  </h2>
                </div>
                <button onClick={() => setShowLinkModal(false)} className="text-sm font-semibold text-gray-700 hover:text-gray-900 underline transition-colors" data-id="element-2882" data-mp="3qaizdhozepwr">
                  Close
                </button>
              </div>

              <div className="mb-6" data-id="element-2883" data-mp="3gjo8u14pd45i">
                <p className="text-sm text-gray-600 mb-4" data-id="element-2884" data-mp="3lc7pj6yosfej">
                  Share this link with learners to allow them to self-register
                  for the license(s) you select.
                </p>

                {/* Licenses Multi-Select */}
                <div className="mb-4" data-id="element-2885" data-mp="3bmxsdcozk6jk">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-2886" data-mp="2xn58a07ysokk">
                    Licenses <span className="text-[#DB3725]" data-id="element-2887" data-mp="32lzwjhopb5c2">*</span>
                  </label>
                  <div className="relative" ref={linkLicenseDropdownRef} data-id="element-2888" data-mp="32nsveat2ol9i">
                    <div className={`w-full px-4 py-2 border rounded-lg bg-white flex items-center justify-between cursor-text ${isLinkLicenseDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]' : 'border-gray-300'}`} onClick={() => setIsLinkLicenseDropdownOpen(true)} data-id="element-2889" data-mp="2j0gac2td2jga">
                      <input type="text" placeholder={linkLicenses.length + linkPathways.length > 0 ? `${linkLicenses.length + linkPathways.length} item${linkLicenses.length + linkPathways.length > 1 ? 's' : ''} selected — type to search...` : 'Search and select pathways or modules'} value={linkLicenseSearch} onChange={e => {
                    setLinkLicenseSearch(e.target.value);
                    if (!isLinkLicenseDropdownOpen) setIsLinkLicenseDropdownOpen(true);
                  }} onFocus={() => setIsLinkLicenseDropdownOpen(true)} className="flex-1 text-sm bg-transparent outline-none placeholder-gray-400" data-id="element-2890" data-mp="2ny7yclqvxlf7" />
                      <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isLinkLicenseDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2891" data-mp="3fsa47cop3c3h" />
                    </div>
                    {isLinkLicenseDropdownOpen && <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-72 overflow-hidden" data-id="element-2892" data-mp="2i9rifma8vn2k">
                        <div className="max-h-72 overflow-y-auto" data-id="element-2893" data-mp="2r4piddbt803e">
                          {/* Pathways Section */}
                          {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length > 0 && <>
                              <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2894" data-mp="314gchdwgkd2y">
                                <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-2895" data-mp="3a3tks38uivm3">
                                  Pathways
                                </span>
                                <button type="button" onClick={e => {
                          e.stopPropagation();
                          selectAllLinkPathways();
                        }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-2896" data-mp="1fp0riavfqgxb">
                                  {linkPathways.length === pathwayData.length ? 'Deselect all' : 'Select all'}
                                </button>
                              </div>
                              {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-2897" data-mp="1r2j797p5jrk8">
                                    <input type="checkbox" checked={linkPathways.includes(pathway.name)} onChange={() => toggleLinkPathway(pathway.name)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-2898" data-mp="1i2mf2w3k0akf" />
                                    <div data-id="element-2899" data-mp="6mfmwilntmzk">
                                      <div className="text-sm font-semibold text-gray-900" data-id="element-2900" data-mp="1pfrd1mfs2mp">
                                        {pathway.name}
                                      </div>
                                      <div className="text-xs text-gray-500" data-id="element-2901" data-mp="25u1yipa1yuqt">
                                        {pathway.skillCount} skills
                                      </div>
                                    </div>
                                  </label>)}
                            </>}

                          {/* Individual Skills Section */}
                          {availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length > 0 && <>
                              <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2902" data-mp="2ateubziwjc5j">
                                <span className="text-xs font-medium text-black uppercase tracking-wide" data-id="element-2903" data-mp="2fq598jiz01pd">
                                  Individual Skills
                                </span>
                                <button type="button" onClick={e => {
                          e.stopPropagation();
                          selectAllLinkSkills();
                        }} className="text-xs font-medium text-[#30718D] hover:text-[#265a70] transition-colors" data-id="element-2904" data-mp="388smjcrq6cfw">
                                  {linkLicenses.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                                </button>
                              </div>
                              {availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-2905" data-mp="8vurtlmrpx4w">
                                    <input type="checkbox" checked={linkLicenses.includes(skill)} onChange={() => toggleLinkLicense(skill)} className="w-4 h-4 rounded border-gray-400 text-[#30718D] focus:ring-[#30718D]" data-id="element-2906" data-mp="hw14546qcr2h" />
                                    <span className="text-sm text-gray-700" data-id="element-2907" data-mp="1tbpv06n3ua8k">
                                      {skill}
                                    </span>
                                  </label>)}
                            </>}

                          {pathwayData.filter(p => p.name.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length === 0 && availableSkills.filter(skill => skill.toLowerCase().includes(linkLicenseSearch.toLowerCase())).length === 0 && <p className="px-4 py-3 text-sm text-gray-400" data-id="element-2908" data-mp="1o2zy2dvkaozo">
                                No results found
                              </p>}
                        </div>
                      </div>}
                  </div>
                  {(linkPathways.length > 0 || linkLicenses.length > 0) && <div className="flex flex-wrap gap-1.5 mt-2 max-h-24 overflow-y-auto" data-id="element-2909" data-mp="2bsap33n4150m">
                      {linkPathways.map(pathway => <span key={pathway} className="inline-flex items-center gap-1 px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium" data-id="element-2910" data-mp="2kqw7mysl0k1e">
                          <span className="text-[10px] font-semibold uppercase tracking-wide opacity-70 mr-0.5" data-id="element-2911" data-mp="2gqvudhh7yevx">
                            Pathway
                          </span>
                          {pathway}
                          <button type="button" onClick={() => toggleLinkPathway(pathway)} className="hover:text-[#DB3725] transition-colors" data-id="element-2912" data-mp="34alklwm0j28x">
                            ×
                          </button>
                        </span>)}
                      {linkLicenses.map(skill => <span key={skill} className="inline-flex items-center gap-1 px-2 py-1 bg-[#30718D]/10 text-[#30718D] rounded text-xs font-medium" data-id="element-2913" data-mp="2gmbsye24bk9v">
                          {skill}
                          <button type="button" onClick={() => toggleLinkLicense(skill)} className="hover:text-[#DB3725] transition-colors" data-id="element-2914" data-mp="27ngn532zkc73">
                            ×
                          </button>
                        </span>)}
                    </div>}
                </div>

                <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-2915" data-mp="22nvlum0cfrr7">
                  <div className="flex items-center gap-2 mb-2" data-id="element-2916" data-mp="8741l3m746pq">
                    <span className="text-xs font-medium text-gray-500 uppercase" data-id="element-2917" data-mp="88f30ws652do">
                      Registration Link
                    </span>
                    <span className={`text-xs px-2 py-0.5 rounded ${userType === 'learners' ? 'bg-[#30718D]/10 text-[#30718D]' : 'bg-purple-100 text-purple-700'}`} data-id="element-2918" data-mp="3vjoi9ty0yxxg">
                      Learner
                    </span>
                  </div>
                  <div className="flex items-center gap-2" data-id="element-2919" data-mp="r56tpra1ijrr">
                    <code className="flex-1 text-sm text-gray-900 break-all" data-id="element-2920" data-mp="n44tp88au3oq">
                      {generatedLink}
                    </code>
                    <button onClick={handleCopyLink} className="p-2 text-[#30718D] hover:bg-[#30718D]/10 rounded-lg transition-colors flex-shrink-0" data-id="element-2921" data-mp="i3guhz9x2gjf">
                      {linkCopied ? <CheckCircle size={18} data-id="element-2922" data-mp="32wk6950iljc6" /> : <Copy size={18} data-id="element-2923" data-mp="32wtzd1guw6m3" />}
                    </button>
                  </div>
                </div>

                {linkCopied && <motion.p initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="text-sm text-[#007558] mt-2 flex items-center gap-1" data-id="element-2924" data-mp="2nsivccazke0x">
                    <CheckCircle size={14} data-id="element-2925" data-mp="2xpniaecnodis" />
                    Link copied to clipboard!
                  </motion.p>}
              </div>

              <div className="bg-purple-50 rounded-lg p-4 mb-6" data-id="element-2926" data-mp="32jhz9a0vmee6">
                <div className="flex items-start gap-3" data-id="element-2927" data-mp="36hyyz8hywmlk">
                  <Clock size={20} className="text-purple-600 mt-0.5" data-id="element-2928" data-mp="3bi3d4rvel58m" />
                  <div data-id="element-2929" data-mp="3bk6eg820aksn">
                    <p className="text-sm font-medium text-gray-900 mb-1" data-id="element-2930" data-mp="3gh6ikdfapdh4">
                      Link Expiration
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-2931" data-mp="3lf84r780pswt">
                      This link will expire in 7 days. You can generate a new
                      link at any time.
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex gap-3" data-id="element-2932" data-mp="3hjc50wp6voys">
                <button onClick={() => {
              setShowLinkModal(false);
              setIsLinkLicenseDropdownOpen(false);
              setLinkLicenseSearch('');
              setLinkPathways([]);
              setLinkLicenses([]);
            }} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors font-medium" data-id="element-2933" data-mp="3hi0xclsmhx2e">
                  Close
                </button>
                <button onClick={handleGenerateLink} disabled={linkLicenses.length === 0 && linkPathways.length === 0} className={`flex-1 px-4 py-2 rounded-lg transition-colors font-medium shadow-sm ${linkLicenses.length > 0 || linkPathways.length > 0 ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-2934" data-mp="2xta3v0pk8mo4">
                  Generate New Link
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Floating Action Bar for Bulk Assignment */}
      <AnimatePresence data-id="element-2935" data-mp="pnhmatqap0ah">
        {selectedCount > 0 && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)] px-4 py-4 sm:px-6 lg:px-8" data-id="element-2936" data-mp="pln0ld77945c">
            <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4" data-id="element-2937" data-mp="19c076z49prjd">
              {/* Left side: badge + dropdowns */}
              <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 flex-1" data-id="element-2938" data-mp="1dcj06whwd3n5">
                <div className="bg-[#30718D]/10 text-[#30718D] px-3 py-2 rounded-lg font-semibold text-sm whitespace-nowrap text-center sm:text-left" data-id="element-2939" data-mp="zdavxp6vn5c3">
                  {selectedLearnerLabel} selected
                </div>

                {/* Assign Skills Dropdown */}
                <div className="relative flex-1 sm:max-w-[240px]" ref={bulkSkillDropdownRef} data-id="element-2940" data-mp="3p3o1snvt77z0">
                  <button onClick={() => {
                if (noLicensesAvailable) {
                  setShowNoLicenseToast(true);
                  setTimeout(() => setShowNoLicenseToast(false), 3000);
                  return;
                }
                setIsBulkSkillDropdownOpen(!isBulkSkillDropdownOpen);
                setIsBulkPathwayDropdownOpen(false);
              }} className={`w-full px-4 py-2 border rounded-lg flex items-center justify-between text-sm ${noLicensesAvailable ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed' : isBulkSkillDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 bg-white' : 'border-gray-300 hover:border-gray-400 bg-white'}`} data-id="element-2941" data-mp="34zp5vp5jip8f">
                    <span className="truncate text-gray-700" data-id="element-2942" data-mp="28bj3l8w3c8xb">
                      {bulkSelectedSkills.length > 0 ? `${bulkSelectedSkills.length} Skills selected` : 'Assign Skills...'}
                    </span>
                    <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isBulkSkillDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2943" data-mp="6jnyxd8954ol" />
                  </button>

                  {isBulkSkillDropdownOpen && <div className="absolute bottom-full mb-2 left-0 w-full sm:w-80 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50" data-id="element-2944" data-mp="izvxdalkek4z">
                      <div className="max-h-80 overflow-y-auto" data-id="element-2945" data-mp="sqi92tq5uqie">
                        <p className="border-b border-gray-100 bg-[#30718D]/5 px-4 py-2 text-xs font-medium text-[#236B8C]" data-id="element-2946" data-mp="3r95qpe5mz6oo">
                          Assigning to {selectedLearnerLabel}
                        </p>
                        <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2947" data-mp="51fszqb6d5q0">
                          <span className="text-xs font-medium text-gray-900" data-id="element-2948" data-mp="94m0t2dxr4yl">
                            Individual Skills
                          </span>
                          <button onClick={() => toggleBulkSkill('all')} className="text-xs font-medium text-[#30718D] hover:text-[#265a70]" data-id="element-2949" data-mp="1kipoxrxudyvq">
                            {bulkSelectedSkills.length === availableSkills.length ? 'Deselect all' : 'Select all'}
                          </button>
                        </div>
                        {availableSkills.map(skill => <label key={skill} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0" data-id="element-2950" data-mp="2gaum9x86w8nz">
                            <input type="checkbox" checked={bulkSelectedSkills.includes(skill)} onChange={() => toggleBulkSkill(skill)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-2951" data-mp="2pa7y2wjsd9bv" />
                            <span className="text-sm text-gray-700" data-id="element-2952" data-mp="2z7vx3yofd2zu">
                              {skill}
                            </span>
                          </label>)}
                      </div>
                    </div>}
                </div>

                {/* Assign Pathways Dropdown */}
                <div className="relative flex-1 sm:max-w-[240px]" ref={bulkPathwayDropdownRef} data-id="element-2953" data-mp="zwusz53unh9p">
                  <button onClick={() => {
                if (noLicensesAvailable) {
                  setShowNoLicenseToast(true);
                  setTimeout(() => setShowNoLicenseToast(false), 3000);
                  return;
                }
                setIsBulkPathwayDropdownOpen(!isBulkPathwayDropdownOpen);
                setIsBulkSkillDropdownOpen(false);
              }} className={`w-full px-4 py-2 border rounded-lg flex items-center justify-between text-sm ${noLicensesAvailable ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed' : isBulkPathwayDropdownOpen ? 'border-[#30718D] ring-2 ring-[#30718D]/20 bg-white' : 'border-gray-300 hover:border-gray-400 bg-white'}`} data-id="element-2954" data-mp="3bk7px77zuurd">
                    <span className="truncate text-gray-700" data-id="element-2955" data-mp="2nun8isrho5k7">
                      {bulkSelectedPathways.length > 0 ? `${bulkSelectedPathways.length} Pathways selected` : 'Assign Pathways...'}
                    </span>
                    <ChevronDown size={16} className={`text-gray-400 transition-transform flex-shrink-0 ml-2 ${isBulkPathwayDropdownOpen ? 'rotate-180' : ''}`} data-id="element-2956" data-mp="m1fs1g053hwq" />
                  </button>

                  {isBulkPathwayDropdownOpen && <div className="absolute bottom-full mb-2 left-0 w-full sm:w-80 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden z-50" data-id="element-2957" data-mp="1sqlpt777a7wy">
                      <div className="max-h-80 overflow-y-auto" data-id="element-2958" data-mp="22jjdrsuyop2y">
                        <p className="border-b border-gray-100 bg-[#30718D]/5 px-4 py-2 text-xs font-medium text-[#236B8C]" data-id="element-2959" data-mp="27i4avjex2sn6">
                          Assigning to {selectedLearnerLabel}
                        </p>
                        <div className="flex items-center justify-between px-4 py-2 bg-gray-50 border-b border-gray-100" data-id="element-2960" data-mp="2gi9b99lp0qru">
                          <span className="text-xs font-medium text-gray-900" data-id="element-2961" data-mp="2lgapnh86c1wz">
                            Pathways
                          </span>
                          <button onClick={() => toggleBulkPathway('all')} className="text-xs font-medium text-[#30718D] hover:text-[#265a70]" data-id="element-2962" data-mp="r3kukw62kmo0">
                            {bulkSelectedPathways.length === pathwayData.map(p => p.name).length ? 'Deselect all' : 'Select all'}
                          </button>
                        </div>
                        {pathwayData.map(pathway => <label key={pathway.name} className="flex items-center gap-3 px-4 py-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100" data-id="element-2963" data-mp="9ujq87ljxsty">
                            <input type="checkbox" checked={bulkSelectedPathways.includes(pathway.name)} onChange={() => toggleBulkPathway(pathway.name)} className="w-4 h-4 rounded border-gray-300 text-[#30718D] focus:ring-[#30718D]" data-id="element-2964" data-mp="12j7japcjlmi2" />
                            <div data-id="element-2965" data-mp="six3cwz4i0z7">
                              <div className="text-sm font-bold text-gray-900" data-id="element-2966" data-mp="nlouxo3s1bb5">
                                {pathway.name}
                              </div>
                              <div className="text-xs text-gray-500" data-id="element-2967" data-mp="3dcac4a96ob75">
                                {pathway.skillCount} skills
                              </div>
                            </div>
                          </label>)}
                      </div>
                    </div>}
                </div>
              </div>

              {/* Right side: Cancel + Assign */}
              <div className="flex items-center justify-center lg:justify-end gap-3" data-id="element-2968" data-mp="1qd7vo6t0f4mq">
                <button onClick={() => {
              setSelectedUsers([]);
              setBulkSelectedSkills([]);
              setBulkSelectedPathways([]);
            }} className="px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-2969" data-mp="1vckpxcm7ndzc">
                  Cancel
                </button>
                <button onClick={() => {
              if (noLicensesAvailable) {
                setShowNoLicenseToast(true);
                setTimeout(() => setShowNoLicenseToast(false), 3000);
                return;
              }
              handleBulkAssign();
            }} disabled={noLicensesAvailable || bulkSelectedSkills.length === 0 && bulkSelectedPathways.length === 0} className={`flex items-center gap-2 px-6 py-2 rounded-lg text-sm font-medium transition-colors shadow-sm ${noLicensesAvailable ? 'bg-gray-200 text-gray-400 cursor-not-allowed' : bulkSelectedSkills.length > 0 || bulkSelectedPathways.length > 0 ? 'bg-[#DB3725] text-white hover:bg-[#c02f1f]' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`} data-id="element-2970" data-mp="17p2sp1k6fnoz">
                  <CheckCircle size={16} data-id="element-2971" data-mp="o4cf6t7cw1dz" />
                  Assign to {selectedLearnerLabel}
                </button>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}